import moment from 'moment';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import { Link } from 'react-router-dom';
import React, { useEffect, useState } from "react";
import 'react-circular-progressbar/dist/styles.css';
import { useSelector, useDispatch } from "react-redux";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';

import { updateUser } from '../../../reducers/userReducer';
import AnimatedPage from "../../../components/AnimatedPage";
import { toggleModal } from "../../../reducers/modalReducer";
import Certification from "../../../components/Certification";
import { setCompany } from "../../../reducers/companyReducer.js";
import { refreshCompanies } from '../../../reducers/companiesReducer';
import { getRequest, postRequest, showMessage } from '../../../config';
import { DASHBOARD, BILLING, COMPANY } from "../../../constants/routes";

export default function CompanySettings({ profileClass, company, getCompany, handleMemberEdit }) {

	const dispatch = useDispatch();

	let user = useSelector(state => state.user);
	let modal = useSelector(state => state.modal);
	let companies = useSelector(state => state.companies);
	let companyId = location.pathname.split("/").slice(-1)[0];
	let { selectedCompany } = useSelector(state => state.company);
	company = { ...selectedCompany };

	let [cvData, setCvData] = useState({});
	let [director, setDirector] = useState('');
	// OPTIMIZATION: Lazy load directors when not available (excluded in lightweight mode)
	let [directors, setDirectors] = useState(company?.['directors'] || []);
	let [editInput, setEditInput] = useState('');
	let [updateData, setUpdateData] = useState([]);
	let [updateType, setUpdateType] = useState('');
	let [attachment, setAttachment] = useState({});
	let [companiesGroup, setCompaniesGroup] = useState({}); // { companyId: '', group: '', percentage: '' }
	let [filingReadMore, setFilingReadMore] = useState({});
	let [chargeReadMore, setChargeReadMore] = useState({});
	let [controlReadMore, setControlReadMore] = useState({});
	let [officersReadMore, setOfficersReadMore] = useState({});
	let [auditLogList, setAuditLogList] = useState([]);
	let [permissionLogList, setPermissionLogList] = useState([]);
	let [tabIndex, setTabIndex] = useState('Companies House Core Info');
	let [tabCompanySnapshot, setTabCompanySnapshot] = useState('Filing History');
	let [selectAll, setSelectAll] = useState(false);
	let [editUser, setEditUser] = useState({});
	const [userAction, setUserAction] = useState('Search');
	const [filingCurrentPage, setFilingCurrentPage] = useState(0);
	const [officersCurrentPage, setOfficersCurrentPage] = useState(0);
	const [personsCurrentPage, setPersonsCurrentPage] = useState(0);
	const [chargesCurrentPage, setChargesCurrentPage] = useState(0);
	const [registersCurrentPage, setRegistersCurrentPage] = useState(0);

	let [formData, setFormData] = useState({ linkedIn: '', companyId: '', directorId: '' });
	let permissionNames = {
		D002: "Commercial Activities", D003: "Legal", D004: "Property", D005: "Intellectual Property", D006: "Insurance", D007: "Corporate Structure",
		D008: "State Aid", D009: "Finance", D010: "GDPR", D011: "Shares & Share Options", D012: "Taxation", D013: "Social Media", D014: "Key People", D015: "Human Resources",
		D016: "ESG", D017: "Key Advisors", D018: "It Systems", D019: "Regulatory", D020: "Standards", DEPF005: "Environmental, Social, Governmental", DEPF006: "Warranty Disclosure",
		DEPF007: "Directors  Questionnaire", DEPF004: "Software Development",
	};
	let companyKeys = {
		fiveWords: 'Description', companyDescription: 'Detail Box', vatRegCode: 'VAT Code', ukUTRCode: 'UTR Code', cAddress: 'Address Line', cPostalCod: 'Postal Code', cCountry: 'Country',
		cWebsite: 'Website Url', cLinkedin: 'LinkedIn Url', cFacebook: 'Facebook Url', cInstagram: 'Instgram Url'
	};

	// Fetch directors if not available (excluded in lightweight mode)
	useEffect(() => {
		const fetchDirectors = async () => {
			if (company?.['directorsCount'] !== undefined && !company?.['directors']) {
				try {
					const response = await getRequest(`/company/${company._id}/directors`);
					if (response['code'] === 200 && response['body']) {
						setDirectors(response['body']['directors'] || []);
					}
				} catch (e) {
					console.error('Failed to fetch directors:', e);
				}
			} else if (company?.['directors']) {
				setDirectors(company['directors']);
			}
		};
		fetchDirectors();
	}, [company?._id, company?.['directors'], company?.['directorsCount']]);

	const handleUserChange = e => setEditUser({ ...editUser, [e.target.name]: e.target.type === "radio" ? e.target.id : e.target.value });
	const changeUser = (e) => {
		const updatedPermissions = { ...editUser.permissions, [e.target.name]: e.target.checked };
		setEditUser({ ...editUser, permissions: updatedPermissions, });
	};

	function hasAllPermissions(companySections, userPermission) {
		return companySections.every(section => userPermission[section.sectionNo]);
	};

	useEffect(() => {
		if (editUser && editUser?.permissions && company && company['memberPermissions']) {
			setSelectAll(hasAllPermissions(company?.['sections'], editUser?.permissions));
		}
	}, [editUser, company]);

	const findUser = async () => {
		let email = document.getElementById('searchEmail').value;
		let res = await postRequest(`/user/findUser`, { email, companyId });
		showMessage(res['message']);
		if (!res || res['code'] != 200) return;
		if (res['body']['found']) {
			setUserAction('Add');
			setEditUser(res['body']['user']);
		} else {
			editUser['email'] = document.getElementById('searchEmail').value;
			setEditUser(editUser);
			setUserAction('New');
		}
	};

	const saveUser = async () => {
		const permissions = editUser.permissions || {};
		const email = document.getElementById("userEmail").value;
		const lastName = document.getElementById("userLastName").value;
		const firstName = document.getElementById("userFirstName").value;
		const designation = document.getElementById("designation").value;

		let res = '';
		if (userAction == 'Edit') res = await postRequest('/user/editMember', { companyId, firstName, lastName, email, designation, permissions });
		else if (userAction == 'New') res = await postRequest('/user/newMember', { companyId, firstName, lastName, email, designation, permissions });
		else res = await postRequest('/user/addMember', { companyId, firstName, lastName, email, designation, permissions });

		if (!res || res['code'] != 200) return;
		if (getCompany) getCompany();
		else fetchCompany();

		setEditUser({});
		setUserAction('Search');
		showMessage(res['message']);
		setSelectAll(false);
		dispatch(toggleModal({ open: '' }));
	};

	const selectAllPermissions = (event) => {
		const isChecked = event.target.checked;

		setSelectAll(isChecked);
		let permissions = {};
		company?.['sections']?.forEach((section) => {
			if (section.sectionNo.trim() !== "") permissions[section.sectionNo] = isChecked;
		});

		setEditUser({ ...editUser, permissions });
	};

	useEffect(() => {
		// getCompanies();
		let isCompanySettings = localStorage.getItem("isCompanySettings");
		if (isCompanySettings == null) {
			dispatch(toggleModal({ open: 'companySettings' }));
			localStorage.setItem('isCompanySettings', true);
		}
	}, []);

	const fetchCompany = async () => {
		try {
			const res = await getRequest(`/company/get/${companyId}?lightweight=false`);
			dispatch(setCompany(res['body']));
		} catch (error) {
			console.error("Error fetching company data:", error);
		}
	}
	useEffect(() => { fetchCompany() }, [companyId]);

	useEffect(() => {
		setFormData((prevFormData) => ({ ...prevFormData, companyId: companyId }));
	}, [companyId]);

	useEffect(() => {
		setFormData((prevFormData) => ({ ...prevFormData, directorId: director }));
	}, [director]);

	const getCompanies = async () => {
		let response = await getRequest(`/user/myProfile`);
		if (response['body']) {
			let { user, companies } = response['body'];
			let groups = companies.filter(({ group }) => group == 'Parent');
			let standard = companies.filter(({ group }) => group != 'Parent');
			companies = groups.concat(standard);

			dispatch(updateUser(user));
			dispatch(refreshCompanies(companies));
		};
	};

	const saveAnswer = async (e) => {
		updateData = { ...updateData, [e.target.name]: e.target.value };
		await setUpdateData(updateData);

		dispatch(setCompany({ ...company, [e.target.name]: e.target.value }));
		const res = await postRequest(`/company/update/${companyId}`, { update: updateData, companyId });
		if (res || res['code'] == 200) setEditInput('');
	};

	const submitDeleteCompany = async (e) => {
		let requestBody = {
			companyId,
			companyName: company?.['cName'],
			creatorId: company?.['creatorId']?.['_id'],
			creatorEmail: company?.['creatorId']?.['email'],
			creatorName: `${company?.['creatorId']?.['firstName']} ${company?.['creatorId']?.['lastName']}`,
		};
		const res = await postRequest(`/company/delete`, requestBody);
		if (res['code'] == 200) {
			window.location.href = (user?.['role'] == 'Advisor' || user?.['role'] == 'Investor') ? `/${user?.['role']?.toLowerCase()}-dashboard` : DASHBOARD;
			showMessage(res['message']);
		}
	};

	const btnPrev = async (id) => {
		let box = await document.querySelector(id);
		let width = await box.clientWidth;
		box.scrollLeft = box.scrollLeft - width;
	};

	const btnNext = async (id) => {
		let box = await document.querySelector(id);
		let width = await box.clientWidth;
		box.scrollLeft = box.scrollLeft + width;
	};

	const getAuditLogs = async (endpoint) => {
		const res = await postRequest('/log', { endpoint, companyId });
		if (res || res['code'] == 200) {
			await setAuditLogList(res['body']);
			dispatch(toggleModal({ open: 'auditLogs' }));
		}
	};

	const auditLogButton = (path) => {
		return <button onClick={() => getAuditLogs(path)} className="cp df jcc px2rem py0-5rem bg5 fs0-75rem fw500 br30px bw1px bo16 bss">
			<span className='bg5 mr1rem w20px h20px df jcc aic'>
				<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fillRule="evenodd" clipRule="evenodd" d="M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z" fill="#4A67FF" />
				</svg>
			</span>
			<span className='c15'>Audit Log</span>
		</button>
	};

	const companyAuditLogButton = () => {
		return <button onClick={() => dispatch(toggleModal({ open: 'companyAuditLog' }))} className="cp df jcc px2rem py0-5rem bg5 fs0-75rem fw500 br30px bw1px bo16 bss">
			<span className='bg5 mr1rem w20px h20px df jcc aic'>
				<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fillRule="evenodd" clipRule="evenodd" d="M25.2239 26.0269C23.8069 27.2414 21.9654 27.975 19.9525 27.975C15.4761 27.975 11.8479 24.3468 11.8479 19.8704C11.8479 15.394 15.4761 11.7658 19.9525 11.7658C24.4289 11.7658 28.0571 15.394 28.0571 19.8704C28.0571 21.5964 27.5177 23.1964 26.5982 24.5108L29.1267 26.9914L29.2258 26.8894C29.507 26.5989 29.9772 26.592 30.2677 26.8732L34.7187 31.1929C35.0091 31.4741 35.0161 31.9421 34.7326 32.2348L33.1259 33.8898C32.8447 34.1803 32.3768 34.1872 32.084 33.906L27.6353 29.5862C27.3425 29.305 27.3356 28.8348 27.6191 28.5444L27.7028 28.4582L25.2239 26.0269ZM19.9525 13.656C16.5202 13.656 13.7381 16.4382 13.7381 19.8704C13.7381 23.3026 16.5202 26.0849 19.9525 26.0849C23.3847 26.0849 26.167 23.3026 26.167 19.8704C26.167 16.4382 23.3847 13.656 19.9525 13.656ZM19.9525 22.7712C20.3431 22.7712 20.6595 23.0876 20.6595 23.4767C20.6595 23.8673 20.3431 24.1837 19.9525 24.1837C19.562 24.1837 19.2454 23.8673 19.2454 23.4767C19.2454 23.0876 19.562 22.7712 19.9525 22.7712ZM18.9197 18.004C18.9197 18.3946 18.6032 18.7111 18.2127 18.7111C17.8221 18.7111 17.5057 18.3946 17.5057 18.004C17.5057 17.3278 17.7789 16.7165 18.2219 16.2734C18.665 15.8304 19.2764 15.5571 19.9525 15.5571C20.6287 15.5571 21.24 15.8304 21.6831 16.2734C22.1261 16.7165 22.3994 17.3278 22.3994 18.004C22.3994 18.4857 22.2605 18.9349 22.0196 19.3131C21.7726 19.7037 21.416 20.0187 20.993 20.2178C20.8865 20.2672 20.8016 20.3413 20.746 20.4308C20.6905 20.5188 20.6595 20.6268 20.6595 20.7457V21.0946C20.6595 21.4852 20.3431 21.8017 19.9525 21.8017C19.562 21.8017 19.2454 21.4852 19.2454 21.0946V20.7457C19.2454 20.3551 19.3551 19.9877 19.5526 19.6744C19.7503 19.3625 20.0359 19.1093 20.3925 18.9426C20.57 18.8577 20.7213 18.7234 20.8263 18.5567C20.9282 18.3977 20.9869 18.2078 20.9869 18.004C20.9869 17.7184 20.871 17.4606 20.6842 17.2738C20.4959 17.0854 20.2381 16.9712 19.9525 16.9712C19.6669 16.9712 19.4091 17.0854 19.2223 17.2738C19.034 17.4606 18.9197 17.7184 18.9197 18.004ZM18.7753 29.0302C17.2608 29.9784 15.5503 30.6514 13.709 30.9719L13.2649 31.0508L12.8206 30.9719C6.05857 29.7943 1.05859 23.8591 1.05859 16.9889V7.12048L13.2649 1.88672L25.474 7.12048V12.4681C24.7539 11.9301 23.9525 11.4947 23.0917 11.1836V8.96806C23.0917 8.74218 22.957 8.53797 22.7494 8.44902L13.4871 4.48034C13.3451 4.4195 13.1843 4.4195 13.0423 4.48041L3.78316 8.44902C3.57549 8.53804 3.44088 8.74218 3.44088 8.96806V17.0142C3.44088 22.7271 7.56704 27.6829 13.1592 28.7471C13.2289 28.7604 13.3005 28.7604 13.3702 28.7472C14.1727 28.5945 14.9449 28.3618 15.6791 28.0584C16.6264 28.5538 17.6704 28.8895 18.7753 29.0302ZM14.4697 27.3015C14.0779 27.4289 13.6758 27.5345 13.2649 27.617C8.25492 26.6115 4.57029 22.151 4.57029 17.0142V9.34041L13.2648 5.61378L21.9623 9.34048V10.8557C21.3153 10.7122 20.6427 10.6364 19.9525 10.6364C14.8522 10.6364 10.7185 14.7702 10.7185 19.8704C10.7185 22.9176 12.194 25.6198 14.4697 27.3015Z" fill="#4A67FF" />
				</svg>
			</span>
			<span className='c15'>Audit Log</span>
		</button>
	};


	// Delete Company Handler
	const handleDeleteCompany = () => {
		if (company?.childrenCompanies) {
			dispatch(toggleModal({ open: 'warningDeleteCompany' }))
		} else if (company?.isParent && companies?.length > 1) {
			dispatch(toggleModal({ open: 'warningDeleteCompany' }))
		} else {
			dispatch(toggleModal({ open: 'companyDelete' }))
		}
	};

	const getSidebarHTML = () => {
		const tabs = ["Companies House Core Info", "Group Info", "Company Profile", "Director's Info", "Direct/Indirect Channel", "Company Stage Of Development", "Company Objectives", "Subscription Model Info", "Advisor Permissions"];
		return (
			<div id="sidebar-company-settings" style={{ width: "calc((100% - 4rem) / 5)" }} className="sidebar-company-settings w100 bsbb dg gg1rem br5px bg0 ps t0 sidebar-report">
				<div className='bg5 br10px py0-5rem mt3rem bw1px bo16 bss' style={{ backgroundColor: '#F0F2FD50', borderColor: '#7385BE650' }}>
					<div className='df jcc aic fdc p0-5rem'>
						<p className="c3 ttu lh1 fs1-25rem fw500 mt0-5rem tac">Company Settings</p>
						<p className="c3 ttu lh1 fs1-25rem fw500 mt0-5rem tac">Index</p>
						<Link to={`/company/${companyId}`}
							className="c1 bg4 bg-gradient-hover br30px fs0-75rem fw500 px3rem py0-5rem df aic jcc mt1rem">
							<i className="icon mr0-5rem">
								<svg width="15" height="15" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M6.79039 11.7808L2.97655 7.99985L6.79039 4.21887C7.09858 3.91299 7.06263 3.4485 6.70945 3.18134C6.35626 2.91443 5.82021 2.94581 5.51145 3.25144L1.20972 7.51624C0.930093 7.7932 0.930093 8.20671 1.20972 8.48368L5.5115 12.7485C5.67959 12.9147 5.91479 13 6.15137 13C6.34949 13 6.54841 12.9402 6.70945 12.8184C7.06268 12.5512 7.09887 12.0867 6.79039 11.7808Z" fill="white" stroke="white" strokeWidth="0.5" />
									<path d="M14.1607 7.27344H2.20665C1.79909 7.27344 1.46875 7.60374 1.46875 8.01133C1.46875 8.4189 1.79909 8.74923 2.20665 8.74923H14.1607C16.3038 8.74923 18.0472 10.4926 18.0472 12.6355C18.0472 14.7784 16.3038 16.5218 14.1607 16.5218H3.19053C2.78297 16.5218 2.45264 16.8521 2.45264 17.2597C2.45264 17.6673 2.78297 17.9976 3.19053 17.9976H14.1607C17.1172 17.9976 19.523 15.592 19.523 12.6355C19.523 9.67899 17.1175 7.27344 14.1607 7.27344Z" fill="white" stroke="white" strokeWidth="0.5" />
								</svg>
							</i>
							Back
						</Link>
					</div>
					<div className='mah100 mya oya df fdc jcsb mt2-5rem'>
						{tabs.map((tab, idx) => {
							return (
								<button key={idx} onClick={() => { setTabIndex(tab); setUpdateData([]) }}
									className={`bg5 cp w100 df c2 px1rem py0-75rem ${tab == tabIndex && 'c3'}`}>
									<span className='fs0-75rem tal'>{tab}</span>
								</button>
							)
						})}
						<hr className='my0-5rem c16' />
						<button onClick={() => handleDeleteCompany()} className={`bg5 cp delete-active w100 df px1rem py0-5rem`}>
							<span className='fs0-75rem tal'>Delete Company</span>
						</button>
					</div>
				</div>
			</div>
		)
	};

	//********** Companies House Core **********//
	const companiesHouseCore = () => {
		const tabs = ["Filing History", "Officers", "Persons with significant control", "Charges", "Registers"];
		return (
			<div className="sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem">
				<div className="pr">
					<div className='df jcsb aic mb1rem'>
						<h4 className="fs1-5rem fw500 c14">COMPANY INFORMATION</h4>
						{auditLogButton(`/company/update/${companyId}`)}
					</div>
					<div className="p1-5rem c15 fs0-75rem bw1px bo16 br20px bss mb2rem">
						<div className='df jcsb'>
							<div className='df fdc'>
								<p className="w100 mb0-5rem">Company Status: <b>{company?.['cStatus'] ? company?.['cStatus'] : "-"}</b></p>
								<p className="w100 mb0-5rem">Company Number: <b>{company?.['ukRegNo'] ? company?.['ukRegNo'] : "-"}</b></p>
								<p className="w100 mb0-5rem">Company Title: <b>{company?.['cName'] ? company?.['cName'] : "-"}</b></p>
								<p className="w100 mb0-5rem">Company Date of Creation: <b>{company?.['doIncorporation'] ? moment(company?.['doIncorporation']).format('YYYY-MM-DD') : "-"}</b></p>
								<p className="w100 mb0-5rem">Company Address: <b>{company?.['cAddress'] ? company?.['cAddress'] : "-"}</b></p>
								<p className="w100 mb0-5rem">Accounts: {company?.['cAccounts'] ? <><b>Next Accounts Made Up To {company?.['cAccounts']?.['next_made_up_to']}</b> Due By <b>{company?.['cAccounts']?.['next_due']}</b>, Last Accounts Made Up To <b>{company?.['cAccounts']?.['last_accounts']?.['made_up_to']}</b></> : <b>-</b>}</p>
								<p className="w100 mb0-5rem">Confirmation Statement: {company?.['cStatements'] ? <><b>Next Statement Made Up To {company?.['cStatements']?.['next_made_up_to']}</b> Due By <b>{company?.['cStatements']?.['next_due']}</b>, Last Statement Made Up To <b>{company?.['cStatements']?.['last_made_up_to']}</b></> : <b>-</b>}</p>
								{company?.['ukRegNo'] && <div className='df mt1rem'>
									<Link to={`https://find-and-update.company-information.service.gov.uk/company/${company?.['ukRegNo']}`} target='_blank' className='df aic jcc cp bg3 c1 br25px px1-5rem py0-5rem mr1rem fs0-75rem fw500'>
										<img src={require('../../../../images/companies-core-house-white-logo.png')} className="mr0-5rem" />
										Companies House - Direct
									</Link>
									<Link to={`https://find-and-update.company-information.service.gov.uk/company/${company?.['ukRegNo']}/more`} target='_blank' className='df aic jcc cp bg3 c1 br25px px1-5rem py0-5rem fs0-75rem fw500'>
										<img src={require('../../../../images/companies-core-house-white-logo.png')} className="mr0-5rem" />
										View Snapshot
									</Link>
								</div>}
							</div>
							<div><img src={require('../../../../images/companies-house-text.png')} /></div>
						</div>
					</div>
					<div className='mb2rem'>
						<h4 className="fs1-5rem fw500 c14 mb1rem">COMPANY SNAPSHOT</h4>
						<div className='p1-5rem bw1px bo16 br20px bss'>
							<div className='df jcc'>
								{tabs.map((tab, idx) => {
									return (
										<button key={idx} onClick={() => setTabCompanySnapshot(tab)} className={`cp py0-5rem px1rem bg1 fs1rem ${tab == tabCompanySnapshot ? ' c3 fw600' : 'c12 fw400'}`} style={{ borderBottom: tab == tabCompanySnapshot && '2px solid #6366f1' }}>
											{tab}
										</button>
									)
								})}
							</div>
							{tabCompanySnapshot == "Filing History"
								? <>{filingHistoryTab()}</>
								: tabCompanySnapshot == "Officers"
									? <>{officersTab()}</>
									: tabCompanySnapshot == "Persons with significant control"
										? <>{personsSignificantTab()}</>
										: tabCompanySnapshot == "Charges"
											? <>{chargesTab()}</>
											: <>{registersTab()}</>
							}
						</div>
					</div>
					<div className='mb2rem p1-5rem bw1px bo16 br20px bss'>
						<div className='df jcsb'>
							<h4 className="fs1-125rem fw600 c14 mb1rem">HMRC</h4>
						</div>
						<div className='df'>
							<input
								id="vatRegCode"
								name="vatRegCode"
								onBlur={saveAnswer}
								defaultValue={company?.['vatRegCode']}
								placeholder="Please add VAT reg number"
								className="w100 px1rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem mx0-5rem"
							/>
							<input
								id="ukUTRCode"
								name="ukUTRCode"
								onBlur={saveAnswer}
								defaultValue={company?.['ukUTRCode']}
								placeholder="Please add UTR number"
								className="w100 px1rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem mx0-5rem"
							/>
						</div>
					</div>
				</div>
			</div>
		)
	};

	const filingHistoryTab = () => {
		let itemsPerPage = 4;
		let totalPages = company['cFiling'] ? Math.ceil(company['cFiling'].length / itemsPerPage) : 0;

		const handleNext = () => { if (filingCurrentPage < totalPages - 1) setFilingCurrentPage(filingCurrentPage + 1) };
		const handlePrev = () => { if (filingCurrentPage > 0) setFilingCurrentPage(filingCurrentPage - 1) };
		const getCurrentPageItems = () => {
			if (!company['cFiling']) return [];
			let startIndex = filingCurrentPage * itemsPerPage;
			let endIndex = startIndex + itemsPerPage;
			return company['cFiling'].slice(startIndex, endIndex);
		};

		return (
			<div className='p1rem'>
				<p className='c14 fs1-125rem fw600 mb1-5rem tac ttu'>FILING HISTORY</p>
				{company['cFiling'] && company['cFiling'].length > 0 ? <>
					<div className='df fww gap1rem mb1-5rem'>
						{getCurrentPageItems().map((history, idx) => {
							return (
								<div key={idx} className='bg19 br10px p1-5rem m0-5rem pr' style={{ flex: '0 0 calc(45% - 0.5rem)' }}>
									<div className='df aic mb1rem'>
										<p className="fs0-75rem c15 mb0-25rem">
											<i class="fa fa-circle mr0-5rem c12" />
											Category: <span className='fw600'>{history['category'] ? history['category'] : 'Officers'}</span>
										</p>
										<div className='pa' style={{ top: '1.5rem', right: '1.5rem' }}>
											<img className="" src={require(`../../../../images/companies-core-house-logo.png`)} alt="" />
										</div>
									</div>
									<div className='c15 fs0-75rem mb0-75rem w80'>
										<p className="mb0-5rem">File name: <span className='fw600'>{history['description'] || '-'}</span></p>
										<p className="mb0-5rem">Bar Code: <span className='fw600'>{history['barcode'] || '-'}</span></p>
										<p className="mb0-5rem">Transaction ID: <span className='fw600'>{history['transaction_id'] || '-'}</span></p>
										<p className="mb0-5rem">Date: <span className='fw600'>{history['date'] || '-'}</span></p>
									</div>
									{history?.['Location'] &&
										<a href={history['Location']} target='_blank' className='df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600'>
											<img className="mr0-5rem" src={require(`../../../../images/companies-core-house-white-logo.png`)} alt="" />
											View Document
										</a>
									}
								</div>
							)
						})}
					</div>
					{totalPages > 1 && (
						<div className='df jcc aic gap0-5rem'>
							<button className={`c1 df aic jcc br100 p0-5rem mr1rem ${filingCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`} onClick={handlePrev} disabled={filingCurrentPage == 0}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
								</svg>
							</button>
							<button className={`c1 df aic jcc br100 p0-5rem ${(filingCurrentPage == totalPages - 1) ? 'bg12 cna' : 'bg3 cp'}`} onClick={handleNext} disabled={filingCurrentPage == totalPages - 1}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
								</svg>
							</button>
						</div>
					)}
				</> : <div className="w100 tac"><h2 className='my3rem c15 fs1-25rem tac'>Coming Soon!</h2></div>
				}
			</div>
		)
	};

	const officersTab = () => {
		let itemsPerPage = 4;
		let totalPages = company['cOfficers'] ? Math.ceil(company['cOfficers'].length / itemsPerPage) : 0;

		const handleNext = () => { if (officersCurrentPage < totalPages - 1) setOfficersCurrentPage(officersCurrentPage + 1) };
		const handlePrev = () => { if (officersCurrentPage > 0) setOfficersCurrentPage(officersCurrentPage - 1) };
		const getCurrentPageItems = () => {
			if (!company['cOfficers']) return [];
			let startIndex = officersCurrentPage * itemsPerPage;
			let endIndex = startIndex + itemsPerPage;
			return company['cOfficers'].slice(startIndex, endIndex);
		};

		return (
			<div className='p1rem'>
				<p className='c14 fs1-125rem fw600 mb1-5rem tac ttu'>OFFICERS</p>
				{company['cOfficers'] && company['cOfficers'].length > 0 ? <>
					<div className='df fww gap1rem mb1-5rem'>
						{getCurrentPageItems().map((data, idx) => {
							return (
								<div key={idx} className='bg19 br10px p1-5rem m0-5rem pr' style={{ flex: '0 0 calc(45% - 0.5rem)' }}>
									<div className='df aic mb1rem'>
										<p className="fs0-75rem c15 mb0-25rem">
											<i class="fa fa-circle mr0-5rem c12" />
											Role: <span className='fw600'>{data['officer_role'] ? data['officer_role'] : '-'}</span>
										</p>
										<div className='pa' style={{ top: '1.5rem', right: '1.5rem' }}>
											<img className="w70" src={require(`../../../../images/profile-photo.png`)} alt="" />
										</div>
									</div>
									<div className='c15 fs0-75rem mb0-75rem w80'>
										<p className="mb0-5rem">Name: <span className='fw600'>{data['name'] ? data['name'] : '-'}</span></p>
										<p className="mb0-5rem">Appointed On: <span className='fw600'>{data['appointed_on'] ? data['appointed_on'] : '-'}</span></p>
										{data['appointment'] && <p className="mb0-5rem">{data['appointment']['type']} Filing: <a href={data['appointment']['Location']} target='_blank' className='c3 fw600'>View Document</a></p>}
										<p className="mb0-5rem">Address: <span className='fw600'>{data['address']
											? <>{data['address']['premises'] && data['address']['premises']}
												{data['address']['address_line_1'] && ', ' + data['address']['address_line_1']}
												{data['address']['address_line_2'] && ', ' + data['address']['address_line_2']}
												{data['address']['locality'] && ' - ' + data['address']['locality']}
												{data['address']['region'] && ', ' + data['address']['region']}
												{data['address']['country'] && ', ' + data['address']['country']}
											</>
											: '-'
										}</span></p>
									</div>
									<button onClick={() => { setOfficersReadMore(data); dispatch(toggleModal({ open: 'officersReadMore' })) }} className='df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600'>
										<img className="mr0-5rem" src={require(`../../../../images/companies-core-house-white-logo.png`)} alt="" />
										Read More
									</button>
								</div>
							)
						})}
					</div>
					{totalPages > 1 && (
						<div className='df jcc aic gap0-5rem'>
							<button className={`c1 df aic jcc br100 p0-5rem mr1rem ${officersCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`} onClick={handlePrev} disabled={officersCurrentPage == 0}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
								</svg>
							</button>
							<button className={`c1 df aic jcc br100 p0-5rem ${(officersCurrentPage == totalPages - 1) ? 'bg12 cna' : 'bg3 cp'}`} onClick={handleNext} disabled={officersCurrentPage == totalPages - 1}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
								</svg>
							</button>
						</div>
					)}
				</> : <div className="w100 tac"><h2 className='my3rem c15 fs1-25rem tac'>Coming Soon!</h2></div>
				}
			</div>
		)
	};

	const personsSignificantTab = () => {
		let itemsPerPage = 4;
		let totalPages = company['cSignificantControl'] ? Math.ceil(company['cSignificantControl'].length / itemsPerPage) : 0;

		const handleNext = () => { if (personsCurrentPage < totalPages - 1) setPersonsCurrentPage(personsCurrentPage + 1) };
		const handlePrev = () => { if (personsCurrentPage > 0) setPersonsCurrentPage(personsCurrentPage - 1) };
		const getCurrentPageItems = () => {
			if (!company['cSignificantControl']) return [];
			let startIndex = personsCurrentPage * itemsPerPage;
			let endIndex = startIndex + itemsPerPage;
			return company['cSignificantControl'].slice(startIndex, endIndex);
		};

		return (
			<div className='p1rem'>
				<p className='c14 fs1-125rem fw600 mb1-5rem tac ttu'>PERSONS WITH SIGNIFICANT CONTROL</p>
				{company['cSignificantControl'] && company['cSignificantControl'].length > 0 ? <>
					<div className='df fww gap1rem mb1-5rem'>
						{getCurrentPageItems().map((data, idx) => {
							return (
								<div key={idx} className='bg19 br10px p1-5rem m0-5rem pr' style={{ flex: '0 0 calc(45% - 0.5rem)' }}>
									<div className='df aic mb1rem'>
										<p className="fs0-75rem c15 mb0-25rem">
											<i class="fa fa-circle mr0-5rem c12" />
											Significant Control
										</p>
										<div className='pa' style={{ top: '1.5rem', right: '1.5rem' }}>
											<img className="" src={require(`../../../../images/companies-core-house-logo.png`)} alt="" />
										</div>
									</div>
									<div className='c15 fs0-75rem mb0-75rem w80'>
										<p className="mb0-5rem">Name: <span className='fw600'>{data['name'] ? data['name'] : '-'}</span></p>
										<p className="mb0-5rem">Controls:</p>
										{data['natures_of_control'] && data['natures_of_control'].length > 0
											? <ul className='ml1-5rem mb0-5rem'>{data['natures_of_control'].map((control, idx) => (
												<li key={idx} className='fw600'>{control}</li>
											))}</ul>
											: <span className='fw600'>-</span>
										}
									</div>
									<button onClick={() => { setControlReadMore(data); dispatch(toggleModal({ open: 'controlReadMore' })) }} className='df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600'>
										<img className="mr0-5rem" src={require(`../../../../images/companies-core-house-white-logo.png`)} alt="" />
										Read More
									</button>
								</div>
							)
						})}
					</div>
					{totalPages > 1 && (
						<div className='df jcc aic gap0-5rem'>
							<button className={`c1 df aic jcc br100 p0-5rem mr1rem ${personsCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`} onClick={handlePrev} disabled={personsCurrentPage == 0}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
								</svg>
							</button>
							<button className={`c1 df aic jcc br100 p0-5rem ${(personsCurrentPage == totalPages - 1) ? 'bg12 cna' : 'bg3 cp'}`} onClick={handleNext} disabled={personsCurrentPage == totalPages - 1}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
								</svg>
							</button>
						</div>
					)}
				</> : <div className="w100 tac"><h2 className='my3rem c15 fs1-25rem tac'>Coming Soon!</h2></div>
				}
			</div>
		)
	};

	const chargesTab = () => {
		let itemsPerPage = 4;
		let totalPages = company['cCharges'] ? Math.ceil(company['cCharges'].length / itemsPerPage) : 0;

		const handleNext = () => { if (chargesCurrentPage < totalPages - 1) setChargesCurrentPage(chargesCurrentPage + 1) };
		const handlePrev = () => { if (chargesCurrentPage > 0) setChargesCurrentPage(chargesCurrentPage - 1) };
		const getCurrentPageItems = () => {
			if (!company['cCharges']) return [];
			let startIndex = chargesCurrentPage * itemsPerPage;
			let endIndex = startIndex + itemsPerPage;
			return company['cCharges'].slice(startIndex, endIndex);
		};

		return (
			<div className='p1rem'>
				<p className='c14 fs1-125rem fw600 mb1-5rem tac ttu'>CHARGES</p>
				{company['cCharges'] && company['cCharges'].length > 0 ? <>
					<div className='df fww gap1rem mb1-5rem'>
						{getCurrentPageItems().map((data, idx) => {
							return (
								<div key={idx} className='bg19 br10px p1-5rem m0-5rem pr' style={{ flex: '0 0 calc(45% - 0.5rem)' }}>
									<div className='df aic mb1rem'>
										<p className="fs0-75rem c15 mb0-25rem">
											<i class="fa fa-circle mr0-5rem c12" />
											Status: <span className='fw600'>{data['status'] ? data['status'] : '-'}</span>
										</p>
										<div className='pa' style={{ top: '1.5rem', right: '1.5rem' }}>
											<img className="" src={require(`../../../../images/companies-core-house-logo.png`)} alt="" />
										</div>
									</div>
									<div className='c15 fs0-75rem mb0-75rem w80'>
										<p className="mb0-5rem">Persons Entitled: <span className='fw600'>{data['persons_entitled'] ? data['persons_entitled'][0]['name'] : '-'}</span></p>
										<p className="mb0-5rem">Charge Description: <span className='fw600'>{data['classification']['description'] ? data['classification']['description'] : '-'}</span></p>
									</div>
									<button onClick={() => { setChargeReadMore(data); dispatch(toggleModal({ open: 'chargeReadMore' })) }} className='df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600'>
										<img className="mr0-5rem" src={require(`../../../../images/companies-core-house-white-logo.png`)} alt="" />
										Read More
									</button>
								</div>
							)
						})}
					</div>
					{totalPages > 1 && (
						<div className='df jcc aic gap0-5rem'>
							<button className={`c1 df aic jcc br100 p0-5rem mr1rem ${chargesCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`} onClick={handlePrev} disabled={chargesCurrentPage == 0}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
								</svg>
							</button>
							<button className={`c1 df aic jcc br100 p0-5rem ${(chargesCurrentPage == totalPages - 1) ? 'bg12 cna' : 'bg3 cp'}`} onClick={handleNext} disabled={chargesCurrentPage == totalPages - 1}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
								</svg>
							</button>
						</div>
					)}
				</> : <div className="w100 tac"><h2 className='my3rem c15 fs1-25rem tac'>Coming Soon!</h2></div>
				}
			</div>
		)
	};

	const registersTab = () => {
		let itemsPerPage = 4;
		let totalPages = company['cRegisters'] ? Math.ceil(company['cRegisters'].length / itemsPerPage) : 0;

		const handleNext = () => { if (registersCurrentPage < totalPages - 1) setRegistersCurrentPage(registersCurrentPage + 1) };
		const handlePrev = () => { if (registersCurrentPage > 0) setRegistersCurrentPage(registersCurrentPage - 1) };
		const getCurrentPageItems = () => {
			if (!company['cRegisters']) return [];
			let startIndex = registersCurrentPage * itemsPerPage;
			let endIndex = startIndex + itemsPerPage;
			return company['cRegisters'].slice(startIndex, endIndex);
		};

		return (
			<div className='p1rem'>
				<p className='c14 fs1-125rem fw600 mb1-5rem tac ttu'>REGISTERS</p>
				{company['cRegisters'] && company['cRegisters'].length > 0 ? <>
					<div className='df fww gap1rem mb1-5rem'>
						{getCurrentPageItems().map((data, idx) => {
							return (
								<div key={idx} className='bg19 br10px p1-5rem m0-5rem pr' style={{ flex: '0 0 calc(45% - 0.5rem)' }}>
									<div className='df aic mb1rem'>
										<p className="fs0-75rem c15 mb0-25rem">
											<i class="fa fa-circle mr0-5rem c12" />
											Register
										</p>
										<div className='pa' style={{ top: '1.5rem', right: '1.5rem' }}>
											<img className="" src={require(`../../../../images/companies-core-house-logo.png`)} alt="" />
										</div>
									</div>
									<div className='c15 fs0-75rem mb0-75rem w80'>
										<p className="mb0-5rem">Name: <span className='fw600'>DE ROOS, Peter Wouter</span></p>
										<p className="mb0-5rem">Occupation: <span className='fw600'>Occupation:</span></p>
										<p className="mb0-5rem">Address: <span className='fw600'>Lidl House, 14 , Kingston Road - Surbiton</span></p>
									</div>
									<button className='df aic jcc w40 cp bg3 c1 br25px px1rem py0-5rem mt1rem fs0-75rem fw600'>
										<img className="mr0-5rem" src={require(`../../../../images/companies-core-house-white-logo.png`)} alt="" />
										Read More
									</button>
								</div>
							)
						})}
					</div>
					{totalPages > 1 && (
						<div className='df jcc aic gap0-5rem'>
							<button className={`c1 df aic jcc br100 p0-5rem mr1rem ${registersCurrentPage == 0 ? 'bg12 cna' : 'bg3 cp'}`} onClick={handlePrev} disabled={registersCurrentPage == 0}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
								</svg>
							</button>
							<button className={`c1 df aic jcc br100 p0-5rem ${(registersCurrentPage == totalPages - 1) ? 'bg12 cna' : 'bg3 cp'}`} onClick={handleNext} disabled={registersCurrentPage == totalPages - 1}>
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" viewBox="0 0 16 16">
									<path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
								</svg>
							</button>
						</div>
					)}
				</> : <div className="w100 tac"><h2 className='my3rem c15 fs1-25rem tac'>Coming Soon!</h2></div>
				}
			</div>
		)
	};

	//********** Group Info **********// 
	const groupInfo = () => {
		return (
			<div className="sectionWrapper p1rem fs0-75rem mt2rem pr mr1rem ml1rem">
				<div className='df jcsb mb2rem'>
					<h3 className="company-name fs1-25rem c15">{company?.['cName']}</h3>
					{auditLogButton(`/company/updateChild`)}
				</div>
				<div className="df jcfe mb1rem">
					{company?.['group'] == 'Parent' &&
						<div className='df mr2rem'>
							<span onClick={() => { setUpdateType('Add'); dispatch(toggleModal({ open: 'addGroupCompany' })) }} className={`${companies.length == 0 && 'op20 pen '} bg3 bg4-hover c1 br20px py0-5rem px1rem fw600 cp mr1rem df jcc aic`}>
								<i class="fa fa-plus mr0-5rem" aria-hidden="true" /> ADD
							</span>
							<span onClick={() => { setUpdateType('Edit'); dispatch(toggleModal({ open: 'updateGroupCompany' })) }} className="bg3 bg4-hover c1 br20px py0-5rem px1rem fw600 cp mr1rem df jcc aic">
								<i class="fa fa-edit mr0-5rem" /> EDIT
							</span>
							<span onClick={() => { setUpdateType('Delete'); dispatch(toggleModal({ open: 'updateGroupCompany' })) }} className="bg4 c1 br20px py0-5rem px1rem fw600 cp mr1rem df jcc aic">
								<i class="fa fa-trash-o mr0-5rem" /> DELETE
							</span>
						</div>
					}
				</div>
				{company?.['parentId'] && company?.['parentCompany']
					// CHILD WITH PARENT COMPANY
					? <div className='dropdown-company-dahboard'>
						{showCompanyDetails(company?.['parentCompany'])}
						<div className="dropdown-content" style={{ display: "block", top: '0px' }}>
							{showCompanyDetails(company)}
						</div>
					</div>
					// PARENT WITH CHILD COMPANY
					: <div className='dropdown-company-dahboard'>
						{showCompanyDetails(company)}
						{company?.['childrenCompanies'] && company?.['childrenCompanies'].length > 0 && <>
							<div className="dropdown-content" style={{ display: "block", top: '0px' }}>
								{company?.['childrenCompanies'] && company?.['childrenCompanies'].map((childrenCompany, idx) => {
									return <>
										{showCompanyDetails(childrenCompany)}
									</>
								})}
							</div>
						</>}
					</div>
				}
			</div>
		)
	};

	const showCompanyDetails = (company) => {
		return (
			<div className="dg gtcr6-md gg1rem p1rem bw1px bo16 bss br20px bg1 fs1rem mb1rem">
				<div className='df jcse'>
					<h4 className='fs1rem c15 w10rem'>{company?.['cName']}</h4>
					<span className='ml1rem'>
						{company?.['subscription']
							? <h2 className="fs1rem c7 mra tal">{company?.['subscription']?.toUpperCase()}</h2>
							: <h2 className="fs1rem c8 mra tal">INACTIVE</h2>
						}
					</span>
				</div>
				<div className='df jcse'>
					<span className='df username-area ml1rem'>
						<div className="df fdc mr1rem">
							<span className="ass mb0-5rem fs0-75rem">Type</span>
							<span onClick={() => dispatch(toggleModal({ open: 'userDetail' }))} data-tooltip={(company?.['group'] && company?.['group'] !== "Standard") ? company?.['group'] : 'No group'} className="w2rem h2rem df jcc aic fs0-75rem p0-5rem br100 bg4 c1">
								{(company?.['group'] && company?.['group'] !== "Standard") ? company?.['group'][0] : 'N/A'}
							</span>
						</div>
					</span>
					<span className='df username-area'>
						<div className="df fdc">
							<span className="ass mb0-5rem fs0-75rem">Owner</span>
							<span onClick={() => dispatch(toggleModal({ open: 'userDetail' }))} data-tooltip={user.firstName ? (user.firstName + " " + user.lastName) : "Register to show your name here"} className="w2rem h2rem df jcc aic fs0-75rem p0-5rem br100 bg3 c1 mr0-5rem">{user.firstName ? (user.firstName[0] + user.lastName[0]) : "?"}</span>
						</div>
					</span>
				</div>
				<a href={COMPANY.replace(":id", company?.['_id'])} className={`${!company.subscription && 'op20 pen '} tac c1 bg3 br20px px0-25rem py0-5rem fs0-75rem fw500`}>Dashboard</a>
				{company?.['subscription'] && company['subscription'] != 'Pro'
					? <Link to={BILLING.replace(":id", company?.['_id'])} className={`${user['email'] == 'temp' && 'op20 pen '} tac c1 bg3 br20px px1rem py0-5rem fw500 fs0-75rem`}>Upgrade</Link>
					: <Link data-testid="subscribeNow" to={BILLING.replace(":id", company?.['_id'])} className="tac c1 bg3 br20px px1rem py0-5rem fw500 fs0-75rem">Subscribe Now</Link>
				}
				<div className='progress-area progress-dashboard' style={{ display: 'flex', position: 'relative', justifyContent: 'center' }}>
					<div className='progress-box'>
						<div className="progress-bar" style={{ width: 50, height: 50 }}>
							<CircularProgressbar
								className={`${company.stats.completionPercent > 67 ? 'green'
									: company.stats.completionPercent > 33 ? 'orange'
										: 'red'}`}
								value={company.stats.completionPercent || 0}
								text={(company.stats.completionPercent || 0) + "%"}
								styles={buildStyles({
									strokeLinecap: 'round',
									strokeWidth: '5px',
									textSize: '20px',
									pathTransitionDuration: 0.5,
									trailColor: '#d6d6d6',
									backgroundColor: '#fc7785',
									dominantBaseline: 'ideographic',
								})}
							/>
						</div>
						<span style={{ marginBottom: '0', fontSize: '11px' }} className="text-center-area">Completeness</span>
					</div>
					<div className='progress-box'>
						<div className="progress-bar" style={{ width: 50, height: 50 }}>
							<CircularProgressbar
								className={`${company.stats.riskPercent > 67 ? 'red'
									: company.stats.riskPercent > 33 ? 'orange'
										: 'green'}`}
								value={company.stats.riskPercent || 0}
								text={company.stats.completionPercent ? `${(company.stats.riskPercent || 0)}%` : "0%"}
								styles={buildStyles({
									strokeLinecap: 'butt',
									strokeWidth: '5px',
									textSize: '20px',
									pathTransitionDuration: 0.5,
									trailColor: '#d6d6d6',
									backgroundColor: '#fc7785',
									dominantBaseline: 'ideographic',
								})}
							/>
						</div>
						<span style={{ marginBottom: '0', fontSize: '11px' }} className="text-center-area">Risk</span>
					</div>
				</div>
				<div className='certificate-area-dashboard df jcc'>
					{(company?.['cLevel']) && (company?.['subscription'] == "Pro" || company?.['subscription'] == "Pro Plus") &&
						<Certification className={'op70'} component='CompanySettings' level={company?.['subscription'] == "Lite" ? 'None' : company?.['cLevel']} expiryTimestamp={company?.['createdAt']} company={company} subscription={company?.['subscription']} />
					}
				</div>
			</div>
		)
	}

	const handleChildCompany = async (el) => {
		if (!companiesGroup[el['companyId']]) companiesGroup[el['companyId']] = { companyId: el['companyId'] };
		if (el['selected']) companiesGroup[el['companyId']]['selected'] = el['selected'];
		if (el['group']) {
			document.getElementById(`group-${el['companyId']}`).value = el['group'];
			companiesGroup[el['companyId']]['group'] = el['group'];
		}
		if (el['percentage']) {
			document.getElementById(`percentage-${el['companyId']}`).value = el['percentage'];
			companiesGroup[el['companyId']]['percentage'] = el['percentage'];
		}
		if (el['event']?.['target']?.['checked'] == false) delete companiesGroup[el['companyId']];
		setCompaniesGroup(companiesGroup);
	};

	const updateGroupCompany = async () => {
		let childUpdates = await Object.values(companiesGroup).filter(company => {
			if (updateType == "Delete") company['group'] = 'Standard';
			if (!company['group'] && updateType == "Add") company['group'] = 'Subsidiary';
			if (!company['percentage'] && updateType == "Add") company['percentage'] = '0';
			if (company['selected'] == 'true') return company;
		});

		let data = { parentId: company['_id'], childUpdates, type: updateType }
		if (data) {
			const res = await postRequest(`/company/updateChild`, { data, companyId });
			if (res || res['code'] == 200) {
				if (getCompany) getCompany();
				else fetchCompany();
				getCompanies();
				setCompaniesGroup({});
				dispatch(toggleModal({ open: '' }));
				showMessage(res['message']);
			}
		}
		else showMessage("Company is not identified");
	};

	//********** Company Profile **********//
	const companyProfile = () => {
		return (
			<div className="w80 mx1rem">
				<div className='df jcsb aic mb1rem'>
					<h3 className="c14 fs1-5rem fw500 ttu">{company?.['cName']}</h3>
					{auditLogButton(`/company/update/${companyId}`)}
				</div>
				{/* Address */}
				<h4 className="fs1rem fw400 c15 mb0-5rem">Address</h4>
				<div className='mb1rem'>
					<div className='pr'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path d="M9 0C5.40545 0 2.48108 2.92437 2.48108 6.51888C2.48108 10.9798 8.31487 17.5287 8.56325 17.8053C8.79655 18.0651 9.20387 18.0647 9.43674 17.8053C9.68512 17.5287 15.5189 10.9798 15.5189 6.51888C15.5188 2.92437 12.5945 0 9 0ZM9 16.5139C7.03663 14.1817 3.65502 9.5805 3.65502 6.51895C3.65502 3.57166 6.05274 1.17394 9 1.17394C11.9473 1.17394 14.345 3.57166 14.345 6.51892C14.3449 9.58061 10.9639 14.181 9 16.5139Z" fill="#505050" />
							<path d="M9 3.23926C7.19149 3.23926 5.7202 4.71058 5.7202 6.51909C5.7202 8.3276 7.19152 9.79892 9 9.79892C10.8085 9.79892 12.2798 8.3276 12.2798 6.51909C12.2798 4.71058 10.8085 3.23926 9 3.23926ZM9 8.62498C7.83879 8.62498 6.89414 7.6803 6.89414 6.51909C6.89414 5.35788 7.83882 4.4132 9 4.4132C10.1612 4.4132 11.1059 5.35788 11.1059 6.51909C11.1059 7.6803 10.1612 8.62498 9 8.62498Z" fill="#505050" />
						</svg>
						{editInput == 'cAddress'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company?.['cAddress']} name="cAddress" type="text" placeholder="Address Line" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company?.['cAddress'] || ''} placeholder="Address Line" onFocus={() => setEditInput('cAddress')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
				</div>
				<div className='w100 df mb1-5rem'>
					<div className='w50 pr mr1rem'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path fillRule="evenodd" clipRule="evenodd" d="M6.75 3C7.16421 3 7.5 3.33579 7.5 3.75V6H10.5V3.75C10.5 3.33579 10.8358 3 11.25 3C11.6642 3 12 3.33579 12 3.75V6H14.25C14.6642 6 15 6.33579 15 6.75C15 7.16421 14.6642 7.5 14.25 7.5H12V10.5H14.25C14.6642 10.5 15 10.8358 15 11.25C15 11.6642 14.6642 12 14.25 12H12V14.25C12 14.6642 11.6642 15 11.25 15C10.8358 15 10.5 14.6642 10.5 14.25V12H7.5V14.25C7.5 14.6642 7.16421 15 6.75 15C6.33579 15 6 14.6642 6 14.25V12H3.75C3.33579 12 3 11.6642 3 11.25C3 10.8358 3.33579 10.5 3.75 10.5H6V7.5H3.75C3.33579 7.5 3 7.16421 3 6.75C3 6.33579 3.33579 6 3.75 6H6V3.75C6 3.33579 6.33579 3 6.75 3ZM10.5 10.5V7.5H7.5V10.5H10.5Z" fill="#505050" />
						</svg>
						{editInput == 'cPostalCode'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company?.['cPostalCode']} name="cPostalCode" type="text" placeholder="Postal Code" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company?.['cPostalCode'] || ''} placeholder="Postal Code" onFocus={() => setEditInput('cPostalCode')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
					<div className='w50 pr'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path d="M15.3775 1.60232C15.179 1.48669 14.8423 1.32778 14.3885 1.17257C12.5943 0.558914 10.6085 0.558914 8.65143 1.58632C7.10195 2.39934 5.53205 2.39934 4.09686 1.9087C3.96647 1.86413 3.85052 1.82007 3.75001 1.77877V0.749988C3.75001 0.335777 3.4142 0 2.99999 0C2.58578 0 2.25 0.335777 2.25 0.749988V2.25035V9.76384V17.25C2.25 17.6642 2.58578 18 2.99999 18C3.4142 18 3.74998 17.6642 3.74998 17.25V10.8872C5.50758 11.454 7.44152 11.4286 9.34847 10.428C10.8981 9.61492 12.468 9.61492 13.9032 10.1056C14.2567 10.2264 14.5051 10.3436 14.6226 10.412C15.1226 10.7031 15.75 10.3425 15.75 9.76388V2.25039C15.75 1.98348 15.6081 1.73668 15.3775 1.60232ZM14.25 8.64025C12.4924 8.07353 10.5584 8.09919 8.6515 9.09977C7.10191 9.91287 5.53201 9.91287 4.09679 9.42223C3.96647 9.37768 3.85042 9.33363 3.74994 9.29232V3.37402C5.50751 3.94073 7.44152 3.91507 9.34843 2.91449C10.8981 2.10101 12.4679 2.10101 13.903 2.59182C14.0334 2.6364 14.1495 2.68049 14.25 2.72183V8.64025H14.25Z" fill="#505050" />
						</svg>
						{editInput == 'cCountry'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company?.['cCountry']} name="cCountry" type="text" placeholder="Country" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company?.['cCountry'] || ''} placeholder="Country" onFocus={() => setEditInput('cCountry')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
				</div>
				{/* Overview */}
				<h4 className="fs1rem fw400 c15 mb0-5rem">Overview <span className="fs0-75rem fw300 c12 fsi">(200 words generated by AI)</span></h4>
				<div className='mb1-5rem'>
					{editInput == 'companyDescription'
						? <textarea rows={15} onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company?.['companyDescription'] || ''} name="companyDescription" className="w100 p1rem br5px bw1px bo16 bss c15 fs0-75rem" placeholder="Overview..."></textarea>
						: <div onClick={() => setEditInput('companyDescription')} className="w100 p1rem br5px bw1px bo16 bss c15 fs0-75rem cp">{company?.['companyDescription'] || ''}</div>
					}
				</div>
				{/* Web & Socials */}
				<h4 className="fs1rem fw400 c15 mb0-5rem">Web & Socials</h4>
				<div className='w100 df mb1-5rem'>
					<div className='w50 pr mr1rem'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path d="M9 1.125C7.44248 1.125 5.91992 1.58686 4.62489 2.45218C3.32985 3.31749 2.32049 4.5474 1.72445 5.98637C1.12841 7.42534 0.972461 9.00874 1.27632 10.5363C1.58018 12.0639 2.3302 13.4671 3.43154 14.5685C4.53288 15.6698 5.93607 16.4198 7.46367 16.7237C8.99127 17.0275 10.5747 16.8716 12.0136 16.2756C13.4526 15.6795 14.6825 14.6702 15.5478 13.3751C16.4131 12.0801 16.875 10.5575 16.875 9C16.875 6.91142 16.0453 4.90838 14.5685 3.43153C13.0916 1.95469 11.0886 1.125 9 1.125ZM9 15.75C8.29688 15.75 7.38 14.3044 6.96938 11.8125H11.0306C10.62 14.3044 9.70313 15.75 9 15.75ZM6.82875 10.6875C6.77813 10.1587 6.75 9.59625 6.75 9C6.75 8.40375 6.77813 7.84125 6.82875 7.3125H11.1713C11.2219 7.84125 11.25 8.40375 11.25 9C11.25 9.59625 11.2219 10.1587 11.1713 10.6875H6.82875ZM2.25 9C2.25358 8.43063 2.32726 7.86386 2.46938 7.3125H5.70375C5.65313 7.875 5.625 8.4375 5.625 9C5.625 9.5625 5.65313 10.125 5.70375 10.6875H2.46938C2.32726 10.1361 2.25358 9.56937 2.25 9ZM9 2.25C9.70313 2.25 10.62 3.69563 11.0306 6.1875H6.96938C7.38 3.69563 8.29688 2.25 9 2.25ZM12.2963 7.3125H15.5306C15.8232 8.41848 15.8232 9.58152 15.5306 10.6875H12.2963C12.375 10.125 12.375 9.5625 12.375 9C12.375 8.4375 12.375 7.875 12.2963 7.3125ZM15.1088 6.1875H12.1613C11.9947 4.91356 11.5983 3.68044 10.9913 2.54813C11.8964 2.83223 12.732 3.30288 13.4441 3.92972C14.1562 4.55657 14.729 5.32569 15.1256 6.1875H15.1088ZM7.00875 2.54813C6.40171 3.68044 6.00528 4.91356 5.83875 6.1875H2.87438C3.271 5.32569 3.84382 4.55657 4.55593 3.92972C5.26803 3.30288 6.1036 2.83223 7.00875 2.54813ZM2.87438 11.8125H5.83875C6.00528 13.0864 6.40171 14.3196 7.00875 15.4519C6.1036 15.1678 5.26803 14.6971 4.55593 14.0703C3.84382 13.4434 3.271 12.6743 2.87438 11.8125ZM10.9913 15.4519C11.5983 14.3196 11.9947 13.0864 12.1613 11.8125H15.1256C14.729 12.6743 14.1562 13.4434 13.4441 14.0703C12.732 14.6971 11.8964 15.1678 10.9913 15.4519Z" fill="#505050" />
						</svg>
						{editInput == 'cWebsite'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company?.['cWebsite']} name="cWebsite" type="url" placeholder="Website" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company?.['cWebsite'] || ''} placeholder="Website" onFocus={() => setEditInput('cWebsite')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
					<div className='w50 pr'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path d="M6.00024 14.2188H3.81274V7.15625H6.00024V14.2188ZM6.21851 4.90613C6.21851 4.19897 5.64478 3.625 4.93799 3.625C4.22852 3.625 3.65625 4.19897 3.65625 4.90613C3.65625 5.61353 4.22852 6.1875 4.93799 6.1875C5.64478 6.1875 6.21851 5.61353 6.21851 4.90613ZM14.1875 10.3333C14.1875 8.43738 13.787 7.03125 11.5723 7.03125C10.5081 7.03125 9.7937 7.56348 9.50208 8.11694H9.5V7.15625H7.375V14.2188H9.5V10.7122C9.5 9.79382 9.73376 8.90417 10.8721 8.90417C11.9949 8.90417 12.0312 9.95435 12.0312 10.7705V14.2188H14.1875V10.3333ZM17 15.125V2.875C17 1.84106 16.1589 1 15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125ZM15.125 2.25C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125Z" fill="#505050" />
						</svg>
						{editInput == 'cLinkedin'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company?.['cLinkedin']} name="cLinkedin" type="url" placeholder="LinkedIn Url" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company?.['cLinkedin'] || ''} placeholder="LinkedIn Url" onFocus={() => setEditInput('cLinkedin')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
				</div>
				<div className='w100 df mb1-5rem'>
					<div className='w50 pr mr1rem'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path d="M15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125V2.875C17 1.84106 16.1589 1 15.125 1ZM15.75 15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H11.4375V11.1875H13.4384L13.6715 9.25H11.4375V7.15625C11.4375 6.62183 11.8406 6.21875 12.375 6.21875H13.7812V4.40625C13.4111 4.354 12.6971 4.28125 12.375 4.28125C11.6461 4.28125 10.9155 4.58875 10.3706 5.12476C9.8092 5.677 9.5 6.40039 9.5 7.16174V9.25H7.46875V11.1875H9.5V15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125Z" fill="#505050" />
						</svg>
						{editInput == 'cFacebook'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company?.['cFacebook']} name="cFacebook" type="url" placeholder="Facebook URL" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company?.['cFacebook'] || ''} placeholder="Facebook URL" onFocus={() => setEditInput('cFacebook')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
					<div className='w50 pr'>
						<svg width="18" height="18" viewBox="0 0 18 18" fill="none" style={{ position: 'absolute', left: '10px', top: '30%' }} xmlns="http://www.w3.org/2000/svg">
							<path d="M9.15778 17C9.1048 17 9.05182 17 8.99847 16.9998C7.74428 17.0028 6.58542 16.9709 5.45842 16.9023C4.42518 16.8395 3.48203 16.4824 2.73078 15.8699C2.0059 15.2788 1.51088 14.4796 1.25953 13.4947C1.04077 12.6373 1.02918 11.7956 1.01807 10.9816C1.01001 10.3974 1.00171 9.7053 1 9.00144C1.00171 8.29465 1.01001 7.60251 1.01807 7.0184C1.02918 6.20444 1.04077 5.36276 1.25953 4.50521C1.51088 3.52035 2.0059 2.72115 2.73078 2.13009C3.48203 1.51753 4.42518 1.16048 5.45854 1.09761C6.58554 1.02913 7.74464 0.997147 9.00153 1.0002C10.2561 0.997514 11.4146 1.02913 12.5416 1.09761C13.5748 1.16048 14.518 1.51753 15.2692 2.13009C15.9942 2.72115 16.4891 3.52035 16.7405 4.50521C16.9592 5.36264 16.9708 6.20444 16.9819 7.0184C16.99 7.60251 16.9984 8.29465 17 8.99851V9.00144C16.9984 9.7053 16.99 10.3974 16.9819 10.9816C16.9708 11.7955 16.9593 12.6372 16.7405 13.4947C16.4891 14.4796 15.9942 15.2788 15.2692 15.8699C14.518 16.4824 13.5748 16.8395 12.5416 16.9023C11.4623 16.968 10.3536 17 9.15778 17ZM8.99847 15.7498C10.2323 15.7527 11.3651 15.7216 12.4656 15.6547C13.2469 15.6072 13.9243 15.3536 14.4793 14.9011C14.9922 14.4828 15.3455 13.9056 15.5292 13.1857C15.7114 12.4719 15.7219 11.7056 15.732 10.9645C15.7399 10.3843 15.7482 9.697 15.75 8.99998C15.7482 8.30283 15.7399 7.6157 15.732 7.03549C15.7219 6.2944 15.7114 5.52804 15.5292 4.81418C15.3455 4.0942 14.9922 3.51705 14.4793 3.09872C13.9243 2.64632 13.2469 2.39278 12.4656 2.3453C11.3651 2.27828 10.2323 2.2474 9.0014 2.25008C7.76784 2.24715 6.63486 2.27828 5.53435 2.3453C4.75307 2.39278 4.07568 2.64632 3.52073 3.09872C3.00777 3.51705 2.65448 4.0942 2.47076 4.81418C2.28862 5.52804 2.27812 6.29428 2.26799 7.03549C2.26006 7.61619 2.25176 8.30381 2.25005 9.00144C2.25176 9.69602 2.26006 10.3838 2.26799 10.9645C2.27812 11.7056 2.28862 12.4719 2.47076 13.1857C2.65448 13.9056 3.00777 14.4828 3.52073 14.9011C4.07568 15.3535 4.75307 15.6071 5.53435 15.6545C6.63486 15.7216 7.76808 15.7528 8.99847 15.7498ZM8.96869 12.9062C6.8148 12.9062 5.06229 11.1539 5.06229 8.99998C5.06229 6.84604 6.8148 5.09372 8.96869 5.09372C11.1227 5.09372 12.8751 6.84604 12.8751 8.99998C12.8751 11.1539 11.1227 12.9062 8.96869 12.9062ZM8.96869 6.34372C7.50403 6.34372 6.31234 7.53537 6.31234 8.99998C6.31234 10.4646 7.50403 11.6562 8.96869 11.6562C10.4335 11.6562 11.625 10.4646 11.625 8.99998C11.625 7.53537 10.4335 6.34372 8.96869 6.34372ZM13.3126 3.84371C12.7949 3.84371 12.3751 4.26339 12.3751 4.78122C12.3751 5.29904 12.7949 5.71872 13.3126 5.71872C13.8304 5.71872 14.2501 5.29904 14.2501 4.78122C14.2501 4.26339 13.8304 3.84371 13.3126 3.84371Z" fill="#505050" />
						</svg>
						{editInput == 'cInstagram'
							? <input onBlur={(event) => { saveAnswer(event), setEditInput(null) }} defaultValue={company?.['cInstagram']} name="cInstagram" type="url" placeholder="Instagram URL" className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
							: <input readOnly value={company?.['cInstagram'] || ''} placeholder="Instagram URL" onFocus={() => setEditInput('cInstagram')} className="w100 pl2-5rem py0-75rem br5px bw1px bo16 bss c15 fs0-75rem fw300" />
						}
					</div>
				</div>
				<button className='cp tac c1 br25px px2rem py0-75rem fw500' style={{ backgroundColor: '#ff7b7b', border: 'none', fontSize: '0.9rem' }}>Save Changes</button>
			</div>
		)
	};

	//********** Director's Information **********//
	const directorsInfo = () => {
		return (
			<div className="p2rem">
				{company['directors'] && company['directors'].length > 0
					? <div className='df fww gap1-5rem'>
						{company['directors'].map((director, idx) => {
							return (
								<div key={idx} className='p2rem bw1px bo16 br30px bss m1rem' style={{ flex: '0 0 calc(44% - 0.75rem)' }}>
									<div className='df jcsb mb1rem'>
										<div className='df aic'>
											<img src={director?.['headShot']?.['location'] || require('../../../../images/profile-photo.png')} className="w60px h60px br100 mr1rem" />
											<div className='df fdc c15'>
												<p className="w100 fs1rem fw500 c14 mb0-25rem">{director['name'] ? director['name'] : '-'}</p>
												<p className="w100 fs0-75rem fw600">{director['role'] ? director['role'] : 'Director'}</p>
												<p className="w100 fs0-75rem fw400 fsi">{director['designation'] ? director['designation'] : 'llp-designated-member'}</p>
											</div>
										</div>
										<div className='pr'>
											<img src={require('../../../../images/companies-core-house-logo.png')} className="w80" />
										</div>
									</div>
									<div className=''>
										<TextField
											fullWidth
											placeholder="LinkedIn"
											value={formData['directorId'] === director['_id'] && formData['linkedIn'] ? formData['linkedIn'] : (director['linkedIn'] || '')}
											onFocus={(e) => {
												if (!formData['directorId'] || formData['directorId'] !== director['_id']) {
													setFormData({ linkedIn: director['linkedIn'] || '', companyId: company['_id'], directorId: director['_id'] });
												}
											}}
											onBlur={(e) => { if (formData['linkedIn'] && formData['linkedIn'].length > 0 && formData['linkedIn'] !== director['linkedIn']) handleSubmitDirector(); }}
											onChange={(e) => setFormData({ linkedIn: e.target.value, companyId: company['_id'], directorId: director['_id'] })}
											InputProps={{
												style: { borderRadius: "10px", marginBottom: '8px', fontSize: '14px' },
												startAdornment: (
													<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginRight: '8px' }}>
														<path d="M6.00024 14.2188H3.81274V7.15625H6.00024V14.2188ZM6.21851 4.90613C6.21851 4.19897 5.64478 3.625 4.93799 3.625C4.22852 3.625 3.65625 4.19897 3.65625 4.90613C3.65625 5.61353 4.22852 6.1875 4.93799 6.1875C5.64478 6.1875 6.21851 5.61353 6.21851 4.90613ZM14.1875 10.3333C14.1875 8.43738 13.787 7.03125 11.5723 7.03125C10.5081 7.03125 9.7937 7.56348 9.50208 8.11694H9.5V7.15625H7.375V14.2188H9.5V10.7122C9.5 9.79382 9.73376 8.90417 10.8721 8.90417C11.9949 8.90417 12.0312 9.95435 12.0312 10.7705V14.2188H14.1875V10.3333ZM17 15.125V2.875C17 1.84106 16.1589 1 15.125 1H2.875C1.84106 1 1 1.84106 1 2.875V15.125C1 16.1589 1.84106 17 2.875 17H15.125C16.1589 17 17 16.1589 17 15.125ZM15.125 2.25C15.4696 2.25 15.75 2.5304 15.75 2.875V15.125C15.75 15.4696 15.4696 15.75 15.125 15.75H2.875C2.5304 15.75 2.25 15.4696 2.25 15.125V2.875C2.25 2.5304 2.5304 2.25 2.875 2.25H15.125Z" fill="#505050" />
													</svg>
												),
											}}
										/>
									</div>
									<div className='df aic h10'>
										{director?.['cv'] && <>
											<i className="fa fa-circle c4" style={{ fontSize: '10px' }} aria-hidden="true" />
											<a target="_blank" href={director['cv']?.['location']} className="c3 fs0-75rem fw500 tdu">
												<span className="px0-5rem">{director['cv']?.['originalname']}</span>
											</a>
										</>}
									</div>
									<button onClick={() => { showUploadPopup(director); dispatch(toggleModal({ open: 'uploadCvData' })) }} className='df aic jcc cp bg3 c1 br10px px2rem py0-5rem my1rem fw500'>
										<svg className='mr0-75rem' width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g clipPath="url(#clip0_2183_912)">
												<path d="M11.5 23C17.8513 23 23 17.8513 23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5C0 17.8513 5.14873 23 11.5 23Z" fill="white" />
												<path d="M11.4914 17.7883C10.4699 17.7883 9.44852 17.7883 8.4273 17.7883C7.02663 17.7883 6.01589 16.7811 6.0087 15.3809C6.00601 14.8922 6.00601 14.4033 6.0087 13.9142C6.0114 13.4102 6.31687 13.0859 6.78406 13.085C7.25124 13.0841 7.56076 13.4062 7.5639 13.9097C7.56704 14.4133 7.5639 14.9052 7.5639 15.4029C7.56749 15.9249 7.87431 16.229 8.3981 16.2295C10.4672 16.2295 12.5362 16.2295 14.605 16.2295C15.1292 16.2295 15.4365 15.9249 15.4405 15.4034C15.4441 14.9056 15.4405 14.4079 15.4405 13.9102C15.4405 13.4124 15.7509 13.0841 16.2199 13.085C16.6889 13.0859 16.9988 13.4102 16.9948 13.9138C16.9899 14.5503 17.0253 15.1936 16.9454 15.8216C16.7989 16.9707 15.8192 17.782 14.6566 17.7874C13.6041 17.7905 12.5475 17.7883 11.4914 17.7883Z" fill="#4A67FF" />
												<path d="M10.726 7.89412C10.6074 8.00463 10.5377 8.06527 10.473 8.13041C9.97531 8.63309 9.48027 9.13891 8.98029 9.63978C8.62541 9.99557 8.13082 10.0216 7.81008 9.71031C7.48934 9.399 7.50192 8.88824 7.85096 8.53695C8.86709 7.51453 9.88652 6.4957 10.9092 5.48047C11.2686 5.12109 11.7385 5.12109 12.0979 5.48047C13.1275 6.50169 14.1529 7.52726 15.1741 8.55717C15.5101 8.89633 15.5119 9.40619 15.1997 9.71076C14.8875 10.0153 14.3911 10.0019 14.0484 9.6618C13.5408 9.15643 13.0408 8.64297 12.5368 8.13445C12.4716 8.06887 12.402 8.00777 12.2982 7.90984C12.2915 8.0509 12.2834 8.14209 12.2834 8.23328C12.2834 9.84104 12.2856 11.4483 12.2834 13.0561C12.2834 13.6594 11.7524 14.0183 11.2003 13.8036C10.8949 13.6846 10.7291 13.4195 10.7291 13.0314C10.7273 11.4412 10.7273 9.85107 10.7291 8.26113L10.726 7.89412Z" fill="#4A67FF" />
											</g>
											<defs><clipPath id="clip0_2183_912"><rect width="23" height="23" fill="white" /></clipPath></defs>
										</svg>
										Upload CV
									</button>
								</div>
							)
						})}
					</div>
					: <h2 className="c14 w100 mt2rem tac fs1-25rem">This company has no directors!</h2>
				}
			</div>
		)
	};

	const handleCvChange = async (event) => {
		if (event.target.files) {
			const newAttachment = [];
			for (const file of event.target.files) {
				newAttachment.push(file);
			}
			setAttachment(newAttachment);

			const updatedCvData = { ...cvData };
			updatedCvData[director['_id']] = newAttachment[0];
			setCvData(updatedCvData);
		}
	};

	const showUploadPopup = (director) => {
		setDirector(director['_id']);
		const matchingDirector = company?.['directors'].find(d => d['_id'] === director['_id']);
		const linkedInValue = (matchingDirector && matchingDirector['linkedIn'] !== 'undefined') ? matchingDirector['linkedIn'] : null;

		setFormData({ ...formData, linkedIn: linkedInValue });
		setDirector(director)
	};

	const handleSubmit = async () => {
		let data;
		if (attachment) data = { attachment, ...formData };
		else data = { ...formData };
		const regex = /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]{5,30}\/?$/;
		const isValid = regex.test(formData.linkedIn)
		if (!isValid) {
			return showMessage("Please provide a valid linkedin profile url");
		}
		let res = await postRequest('/question/saveCV', data);
		if (res && res['code'] == 200) {
			const { updatedQuestion } = res['body'];
			// Update local directors state
			const updatedDirectors = directors.map(director => {
				if (director['_id'] == updatedQuestion['directorId']) return { ...director, cv: updatedQuestion['files'][0] };
				return director;
			});
			setDirectors(updatedDirectors);

			const updatedCompany = { ...company, directors: updatedDirectors };
			dispatch(setCompany({ ...company, updatedCompany }));

			if (getCompany) await getCompany();
			else fetchCompany();
			closeDirectorPopup();
			showMessage(res['message']);
		}
	};

	const handleSubmitDirector = async () => {
		let data = { ...formData };
		if (formData['linkedIn'] && formData['linkedIn'].length > 0) {
			const regex = /^https:\/\/(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]{5,30}\/?$/;
			const isValid = regex.test(formData['linkedIn']);
			if (!isValid) {
				return showMessage("Please provide a valid linkedin profile url");
			}
		}
		let res = await postRequest('/question/saveCV', data);
		if (res && res['code'] == 200) {
			if (getCompany) await getCompany();
			else fetchCompany();
			showMessage(res['message']);
		}
	};

	const closeDirectorPopup = () => {
		dispatch(toggleModal({ open: '' }));
		setFormData({ ...formData, linkedIn: '' });
	};

	const confirmDeleteFiles = async () => {
		let questionId = "64bf7e6bacdfbb8c415c2cb4";
		let index = company?.directors.findIndex(el => el['_id'] == director['_id']);
		const directorId = director['_id'];
		const res = await postRequest('/repository/deleteFile', { file: attachment, questionId, companyId, directorId });
		if (res && res['code'] == 200) {
			Object.keys(company.modules).map(module => {
				if (module === `directors-questionnaire_${director['_id']}`) {
					dispatch(setCompany(company => {
						const updatedCompany = { ...company };
						const moduleObj = updatedCompany.modules[module];
						if (moduleObj && moduleObj.sections[0]?.subFolders[2]?.questions[0]?.answer?.files) {
							moduleObj.sections[0].subFolders[2].questions[0].answer.files = moduleObj.sections[0].subFolders[2].questions[0].answer.files?.filter(file => {
								return file !== attachment;
							});
						}
						return updatedCompany;
					}));
				}
			})

			const updatedCvData = { ...cvData };
			if (updatedCvData.hasOwnProperty(directorId)) {
				delete updatedCvData[directorId];
			}
			setCvData(updatedCvData);
			if (getCompany) await getCompany();
			else fetchCompany();
			dispatch(toggleModal({ open: '' }));
			showMessage(res.message);
		}
	};

	//********** Direct/Indirect Channel **********// 
	const directIndirectChannel = () => {
		return (
			<div className="sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem">
				<div className='df jcsb'>
					<h3 className="company-name fs1-25rem c15">{company?.['cName']}</h3>
					{companyAuditLogButton()}
				</div>
				<div className="pr mt2rem">
					<div className='c15'>
						<p><b>Type of customer:</b></p>
						<div className='pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem'>
							<label for="directWeb" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox active w2rem h2rem pr">
									<input defaultChecked={company?.['customerType'] && company?.['customerType'] == 'Direct' ? true : false} name="customerTypeDirect" id="customerTypeDirect" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100  lh3 ml0-5rem usn ml1rem">Direct (from the web)?</span>
							</label>

							<label for="advisorPartner" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input defaultChecked={company?.['customerType'] && company?.['customerType'] == 'Indirect' ? true : false} name="customerTypeAdvisor" id="customerTypeAdvisor" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100  lh3 ml0-5rem usn ml1rem">Introduced via a advisor partner?</span>
							</label>

							<label for="Hybrid" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input defaultChecked={company?.['customerType'] && company?.['customerType'] == 'Hybrid' ? true : false} name="customerTypeHybrid" id="customerTypeHybrid" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100  lh3 ml0-5rem usn ml1rem">Hybrid</span>
							</label>
							<span className="tooltip-area-company-settings pa cp" data-tooltip={"This is the type of customer you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform"}>
								<i className="icon" data-tooltip={"This is the type of customer you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform"}>
									<img data-tooltip={"This is the type of customer you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform"} src={require(`../../../../images/info-icon.svg`)} alt="" />
								</i>
							</span>
						</div>
					</div>
					<div className='c15 mt2rem'>
						<p><b>Payment Source:</b></p>
						<div className='pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem'>
							<label for="directWebpayment" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input defaultChecked={company?.['paymentSource'] && company?.['paymentSource'] == 'Direct' ? true : false} name="paymentSourceDirect" id="paymentSourceDirect" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100  lh3 ml0-5rem usn ml1rem">Direct (from the web)?</span>
							</label>

							<label for="advisorPartnerpayment" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input defaultChecked={company?.['paymentSource'] && company?.['paymentSource'] == 'Paid' ? true : false} name="paymentSourcePaid" id="paymentSourcePaid" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100  lh3 ml0-5rem usn ml1rem">Paid via a advisor partner?</span>
							</label>

							<label for="Other" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input defaultChecked={company?.['paymentSource'] && company?.['paymentSource'] == 'Other' ? true : false} name="paymentSourceOther" id="paymentSourceOther" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100  lh3 ml0-5rem usn ml1rem">Other</span>
							</label>
							<span className="tooltip-area-company-settings pa cp" data-tooltip={"This is the payment source you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform"}>
								<i className="icon" data-tooltip={"This is the payment Source you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform"}>
									<img data-tooltip={"This is the payment Source you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform"} src={require(`../../../../images/info-icon.svg`)} alt="" />
								</i>
							</span>
						</div>
					</div>
				</div>
			</div>
		)
	};

	//********** Company Stage of Development **********// 
	const companyStageofDevelopment = () => {
		return (
			<div className="sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem">
				<div className='df jcsb'>
					<h3 className="company-name fs1-25rem c15">{company?.['cName']}</h3>
					{companyAuditLogButton()}
				</div>
				<div className="pr mt2rem">
					<div className='c15'>
						<p><b>Stage of development:</b></p>
						<div className='pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem'>
							<label for="Pre-Revenue" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input defaultChecked={company?.['cStage'] && company?.['cStage'] == 'Pre-Revenue' ? true : false} name="preRevenue" id="preRevenue" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100 fs0-75rem lh3 ml0-5rem usn ml1rem">Pre-Revenue</span>
							</label>
							<label for="Post-Revenue Early Stage" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input defaultChecked={company?.['cStage'] && company?.['cStage'] == 'Post-Revenue Early Stage' ? true : false} name="postRevenueEarlyStage" id="postRevenueEarlyStage" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100 fs0-75rem lh3 ml0-5rem usn ml1rem">Post-Revenue Early Stage</span>
							</label>
							<label for="Mature" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input defaultChecked={company?.['cStage'] && company?.['cStage'] == 'Mature' ? true : false} name="mature" id="mature" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100  lh3 ml0-5rem usn ml1rem">Mature</span>
							</label>
							<span className="tooltip-area-company-settings pa cp" data-tooltip={"This is the stage of development you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform"}>
								<i className="icon" data-tooltip={"This is the stage of development you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform"}>
									<img data-tooltip={"This is the stage of development you selected when<br /> you registered this company. It is not capable<br /> of being edited on this MVP version of the platform"} src={require(`../../../../images/info-icon.svg`)} alt="" />
								</i>
							</span>
						</div>
						{company?.['cStage'] && company?.['cStage'] == 'Pre-Revenue' && <div className='pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem'><span className='c15'>Company stage {company?.['cStage']} means that we tweak our AI algoirthms to focus on prerevenue issues your business is likely to face.</span></div>}
						{company?.['cStage'] && company?.['cStage'] == 'Post-Revenue Early Stage' && <div className='pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem'><span className='c15'>Company stage {company?.['cStage']} means that we tweak our AI algoirthms to focus on issues that a company at your stage of development is likely to face.</span></div>}
						{company?.['cStage'] && company?.['cStage'] == 'Mature' && <div className='pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem'><span className='c15'>Company stage {company?.['cStage']} means that we tweak our AI algoirthms to focus on the issues faced by a more mature business.</span></div>}
					</div>
				</div>
			</div>
		)
	};

	//********** Company Objectives **********// 
	const companyObjectives = () => {
		return (
			<div className="sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem">
				<div className='df jcsb'>
					<h3 className="company-name fs1-25rem c15">{company?.['cName']}</h3>
					{companyAuditLogButton()}
				</div>
				<div className="pr mt2rem">
					<div className='c15'>
						<p><b>Company Objectives:</b></p>
						<div className='pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem'>
							<label for="Lookingforinvestment" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input defaultChecked={company?.['testType'] && company?.['testType'] == 'investment' ? true : false} name="investment" id="investment" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100 lh3 ml0-5rem usn ml1rem">Looking for investment</span>
							</label>

							<label for="Accelerategrowth" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input defaultChecked={company?.['testType'] && company?.['testType'] == 'growth' ? true : false} name="growth" id="growth" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100 lh3 ml0-5rem usn ml1rem">Accelerate growth</span>
							</label>

							<label for="Lookingtoexit" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input defaultChecked={company?.['testType'] && company?.['testType'] == 'exit' ? true : false} name="exit" id="exit" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" />
								</span>
								<span className="w100 lh3 ml0-5rem usn ml1rem">Looking to exit</span>
							</label>
							<span className="tooltip-area-company-settings pa cp" data-tooltip={"This is the objective you have selected for this<br /> company on the Diligentsia platform – questions and<br /> answers will be tailored to this objective"}>
								<i className="icon" data-tooltip={"This is the objective you have selected for this<br /> company on the Diligentsia platform – questions and<br /> answers will be tailored to this objective"}>
									<img data-tooltip={"This is the objective you have selected for this<br /> company on the Diligentsia platform – questions and<br /> answers will be tailored to this objective"} src={require(`../../../../images/info-icon.svg`)} alt="" />
								</i>
							</span>
						</div>
						{company?.['testType'] && company?.['testType'] == 'investment' && <div className='pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem'><span className='c15'>Company type {company?.['testType']} means that we tweak our AI algoirthms to focus on preparing your business to make it more investment ready.</span></div>}
						{company?.['testType'] && company?.['testType'] == 'growth' && <div className='pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem'><span className='c15'>Company type {company?.['testType']} means that we tweak our AI algoirthms to  focus on preparing your business to turbocharge your growth.</span></div>}
						{company?.['testType'] && company?.['testType'] == 'exit' && <div className='pr df jcsb w60 p1rem bw1px br10px bo16 bss bg1 my1rem'><span className='c15'>Company type {company?.['testType']} means that we tweak our AI algoirthms to focus on preparing your business to make it more exit ready.</span></div>}
					</div>
				</div>
			</div>
		)
	};

	//********** Subsription Model Info **********// 
	const subscriptionModelInfo = () => {
		return (
			<div className="sectionWrapper p1rem fs1rem mt2rem pr mr2rem ml1rem">
				<div className='df jcsb'>
					<h3 className="company-name fs1-25rem c15">{company?.['cName']}</h3>
					{companyAuditLogButton()}
				</div>
				<div className="pr mt2rem">
					<h3 class="c14">{company?.['cName']} Subscriptions:</h3>
					<div className='c15 mt1rem'>
						<p><b>Core Modules:</b></p>
						<div className='pr df jcsb w60 p1rem pb2rem bw1px br10px bo16 bss bg1 my1rem'>
							<label for="DevelopmentPartner" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input disabled={company?.['subscription'] && company?.['subscription'] == 'Free' ? false : true} defaultChecked={company?.['subscription'] && company?.['subscription'] == 'Free' ? true : false} name="free" id="free" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" style={{ cursor: company?.['subscription'] && company?.['subscription'] == 'Free' ? 'pointer' : 'not-allowed' }} />
								</span>
								<span className="w100 fs0-75rem lh3 ml0-5rem usn ml1rem">Free</span>
							</label>
							<label for="Lite" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input disabled={company?.['subscription'] && company?.['subscription'] == 'Lite' ? false : true} defaultChecked={company?.['subscription'] && company?.['subscription'] == 'Lite' ? true : false} name="lite" id="lite" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" style={{ cursor: company?.['subscription'] && company?.['subscription'] == 'Lite' ? 'pointer' : 'not-allowed' }} />
								</span>
								<span className="w100  lh3 ml0-5rem usn ml1rem">Lite</span>
							</label>
							<label for="Pro" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input disabled={company?.['subscription'] && company?.['subscription'] == 'Pro' ? false : true} defaultChecked={company?.['subscription'] && company?.['subscription'] == 'Pro' ? true : false} name="pro" id="pro" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" style={{ cursor: company?.['subscription'] && company?.['subscription'] == 'Pro' ? 'pointer' : 'not-allowed' }} />
								</span>
								<span className="w100  lh3 ml0-5rem usn ml1rem">Pro</span>
							</label>
							<label for="ProPlus" className="py0-5rem df cp mb0-5rem label-checkbox">
								<span className="checkbox w2rem h2rem pr">
									<input disabled={company?.['subscription'] && company?.['subscription'] == 'Pro Plus' ? false : true} defaultChecked={company?.['subscription'] && company?.['subscription'] == 'Pro Plus' ? true : false} name="proPlus" id="proPlus" className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="radio" style={{ cursor: company?.['subscription'] && company?.['subscription'] == 'Pro Plus' ? 'pointer' : 'not-allowed' }} />
								</span>
								<span className="w100  lh3 ml0-5rem usn ml1rem">Pro PLUS</span>
							</label>
							{company?.['createdAt'] &&
								<span className="pa fs0-75rem fw600 mt0-5rem" style={{ top: '70px', left: '230px' }}>
									Renewal Date: {moment(new Date(company?.['createdAt']).setFullYear(new Date(company?.['createdAt']).getFullYear() + 1)).format('DD/MMM/YYYY')}
								</span>
							}
							<span className="tooltip-area-company-settings pa cp" data-tooltip={"This lists the SaaS modules you have subscribed<br /> to for this company – you can change this by upgrading<br /> from your company dashboard"}>
								<i className="icon" data-tooltip={"This lists the SaaS modules you have subscribed<br /> to for this company – you can change this by upgrading<br /> from your company dashboard"}>
									<img data-tooltip={"This lists the SaaS modules you have subscribed<br /> to for this company – you can change this by upgrading<br /> from your company dashboard"} src={require(`../../../../images/info-icon.svg`)} alt="" />
								</i>
							</span>
						</div>
					</div>
					<div className='c15 mt1rem'>
						<p><b>Expansion Packs:</b></p>
						<div className='w100 p1rem px2rem bw1px br10px bo16 bss bg1 my1rem'>
							<ul className='fs0-75rem'>
								{company?.['expensions'] && Object.keys(company?.['expensions']).length > 0
									? <>
										{company?.['expensions']['DEPN004'] && <li><span className='fw500'>DEPN004</span> – Industry Expansion Pack – Software Development{isNaN(company?.['expensions']['DEPN004']) && <span className='fw600'> - (Renewal Date: {moment(new Date(company?.['expensions']['DEPN004']).setFullYear(new Date(company?.['expensions']['DEPN004']).getFullYear() + 1)).format('DD/MMM/YYYY')})</span>}</li>}
										{company?.['expensions']['DEPF005'] && <li><span className='fw500'>DEPF005</span> – Function Expansion Pack - Environmental Social & Governmental (ESG) {isNaN(company?.['expensions']['DEPF005']) && <span className='fw600'> - (Renewal Date: {moment(new Date(company?.['expensions']['DEPF005']).setFullYear(new Date(company?.['expensions']['DEPF005']).getFullYear() + 1)).format('DD/MMM/YYYY')}) </span>}</li>}
										{company?.['expensions']['DEPF006'] && <li><span className='fw500'>DEPF006</span> – Function Expansion Pack – Warranty Disclosure Schedule {isNaN(company?.['expensions']['DEPF006']) && <span className='fw600'> - (Renewal Date: {moment(new Date(company?.['expensions']['DEPF006']).setFullYear(new Date(company?.['expensions']['DEPF006']).getFullYear() + 1)).format('DD/MMM/YYYY')}) </span>}</li>}
										{company?.['expensions']['DEPF007'] && <li><span className='fw500'>DEPF007</span> – Expansion Pack – DD – Directors Questionnaire {isNaN(company?.['expensions']['DEPF007']) && <span className='fw600'> - (Renewal Date: {moment(new Date(company?.['expensions']['DEPF007']).setFullYear(new Date(company?.['expensions']['DEPF007']).getFullYear() + 1)).format('DD/MMM/YYYY')}) </span>}</li>}
									</>
									: <h2 className="w100 my2rem tac fs1rem">This company has no expansion pack subscriptions at this time</h2>
								}
							</ul>
						</div>
					</div>
				</div>
			</div>
		)
	};

	//********** User Permissions **********// 
	const userPermissions = () => {
		return (
			<div className="sectionWrapper p1rem fs0-75rem mt2rem pr mr2rem ml1rem report-page">
				<div className='df jcc'>
					<button disabled={user['role'] == 'Advisor' || user['role'] == 'Investor'} className={`shadow c1 td250 br5px px1rem py0-5rem mx1rem fw600 cp ttu bsbb tac df jcc aic ${(user['role'] == 'Advisor' || user['role'] == 'Investor') ? 'bg12' : 'bg3 bg4-hover'}`} onClick={() => dispatch(toggleModal({ open: 'editUser' }))}>
						Add New Member
					</button>
					{company?.['members'].length > 0 && <>
						<button className={`bg3 bg4-hover shadow c1 td250 br5px px1rem py0-5rem mx1rem fw600 cp ttu bsbb tac df jcc aic`} onClick={() => dispatch(toggleModal({ open: 'userList' }))}>
							All Members
						</button>
						<button className={`bg3 bg4-hover shadow c1 td250 br5px px1rem py0-5rem mx1rem fw600 cp ttu bsbb tac df jcc aic`} onClick={() => getPermissionsLogs()}>
							Audit Log
						</button>
					</>}
				</div>
				{company?.['members'] && company?.['members'].length == 0
					? <h1 className='tac mt2rem'>No Members Created!</h1>
					: <div className='table-permission mt2rem'>
						<table id="table" className="table-userPermissions">
							<thead className="ps t0">
								<tr>
									<th className='index-table'>Modules</th>
									{company?.['creatorId'] &&
										<th className='user-area'>
											<div className="df jcc aic">
												<div className='mr1rem'>
													{company?.['creatorId']?.['profile']
														? <img data-tooltip={company?.['creatorId']?.firstName + " " + company?.['creatorId']?.lastName} src={company?.['creatorId']?.['profile']} className={`w2rem h2rem df jcc aic br100 ${profileClass}`} />
														: <span data-tooltip={company?.['creatorId']?.firstName + " " + company?.['creatorId']?.lastName} className={`w2rem h2rem df jcc aic br100 ${profileClass}`}>{company?.['creatorId']?.firstName ? (company?.['creatorId']?.firstName[0] + company?.['creatorId']?.lastName[0]) : "?"}</span>
													}
												</div>
												<span>{company?.['creatorId']['firstName']} {company?.['creatorId']['lastName']} <br /> (Owner)</span>
											</div>
											<div className='df jcc fdc'>
												<p className='fs0-75rem ml3rem'>Status: <span className='c7 mr0-5rem'>Activated </span></p>
												{company?.['creatorId']?.['lastLogin'] && <p className='fs0-75rem ml3rem'> Last Login: <span className={((new Date().getTime() - new Date(company?.['creatorId']['lastLogin']).getTime()) / (1000 * 3600 * 24 * 30)) > 3 ? 'c9' : 'c7'}>{moment(company?.['creatorId']['lastLogin']).format('ll')}</span></p>}
											</div>
										</th>
									}
									{company?.['members'] && company?.['members'].map(member => {
										return (
											<th className='user-area'>
												<div className="df jcc aic cp" onClick={() => handleMemberEdit(member)}>
													<div className='mr1rem'>
														{member?.profile
															? <img data-tooltip={member?.firstName + " " + member?.lastName} src={member?.profile} className="w2rem h2rem df jcc aic br100 bg4 c1" />
															: <span data-tooltip={member?.firstName + " " + member?.lastName} className="w2rem h2rem df jcc aic br100 bg4 c1">{member?.firstName ? (member?.firstName[0] + member?.lastName[0]) : "?"}</span>
														}
													</div>
													<span>{member['firstName']} {member['lastName']} <br /> ({member['designation']})</span>
												</div>
												<div className='df jcc fdc fs0-75rem ml3rem'>
													<p>Status: <span className={`${member['emailVerified'] ? ' c7' : ' c8'} mr0-5rem`}>{member['emailVerified'] ? 'Activated' : <span>Invite Sent - <br /> ({moment(member['updatedAt']).format('ll')})</span>}</span></p>
													{member['emailVerified'] && <p> Last Login: <span className={((new Date().getTime() - new Date(member['lastLogin']).getTime()) / (1000 * 3600 * 24 * 30)) > 3 ? 'c9' : 'c7'}>{moment(member['lastLogin']).format('ll')}</span></p>}
												</div>
											</th>
										)
									})}
								</tr>
							</thead>
							<tbody>
								{company?.['sections'] && company?.['sections'].map((section, idx) => {
									return <tr>
										{/* Map Sections */}
										<td className='c6' key={idx}>
											<span className='fw600'>{section['sectionNo']}</span> {section['sectionName']}
										</td>
										{/* Map Owner Permission */}
										<td className='c6 cp' key={idx}>
											<label for={`owner-permission-${idx}`} className="df jcc cp fs0-75rem">
												<span className='checkbox w2rem h2rem pr'>
													<input disabled={true} defaultChecked={true} id={`permission-${idx}`} className="shadow bw2px bss cp td250 w2rem h2rem br5px" type="checkbox" style={{ backgroundColor: '#8f8f8f', borderColor: '#8f8f8f' }} />
												</span>
											</label>
										</td>
										{/* Map Members Permission of that section */}
										{company?.['members'] && company?.['members'].map((member, idx) => {
											return (
												<td className='c6 cp' key={idx}>
													<label for={`member-permission-${idx}`} className="df jcc cp fs0-75rem">
														<span className='checkbox w2rem h2rem pr'>
															<input checked={company?.['memberPermissions']?.[member['_id']]?.[section['sectionNo']]} onChange={(e) => setPermissions(e, section['sectionNo'], member)} id={`${section['sectionNo']}-${member['_id']}`} className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px" type="checkbox" />
														</span>
													</label>
												</td>
											)
										})}
									</tr>
								})}
							</tbody>
						</table>
					</div>
				}
			</div>
		)
	};

	const setPermissions = async (e, sectionNo, member) => {
		let permissions = company?.['memberPermissions']?.[member['_id']];
		permissions = { ...permissions, [sectionNo]: e.target.checked };

		if (company?.['memberPermissions']?.[member['_id']]) {
			company['memberPermissions'] = { ...company?.['memberPermissions'], [member['_id']]: permissions };
			await dispatch(setCompany(company))
			savePermissions();
		}
	};

	const savePermissions = async () => {
		// User Updated
		const res = await postRequest(`/company/updatePermission/${companyId}`, { permissions: company?.['memberPermissions'] });
		if (res || res['code'] == 200) showMessage(res['message']);
	};

	const getPermissionsLogs = async () => {
		const res = await postRequest('/company/permissionsLogs', { companyId });
		if (res || res['code'] == 200) {
			await setPermissionLogList(res['body']);
			dispatch(toggleModal({ open: 'permissionsLogs' }));
		}
	};

	//********** Advisor Permissions **********// 
	const advisorPermissions = () => {
		return (
			<div className="sectionWrapper c15 p1rem fs1rem mt2rem pr mr2rem ml1rem">
				<h3 className="company-name fs1-75rem">{company?.['cName']}</h3>
				<div className="pr mt2rem">
					<h3>Stage of development:</h3>
					{[
						{ number: 'D017.1', title: 'Accountants' },
						{ number: 'D017.2', title: 'Lawyers' },
						{ number: 'D017.3', title: 'Intellectual Property Advisors' },
						{ number: 'D017.4', title: 'Property Advisors' },
						{ number: 'D017.5', title: 'PR & Media Advisors' },
						{ number: 'D017.6', title: 'Corporate Finance Advisors' },
						{ number: 'D017.7', title: 'Commercial Bankers' },
						{ number: 'D017.8', title: 'Investment Bankers' },
						{ number: 'D017.9', title: 'Insurance Brokers' },
						{ number: 'D017.10', title: 'GDPR Advisors' },
						{ number: 'D017.11', title: 'Registrars' },
						{ number: 'D017.12', title: 'Corporate Brokers' },
						{ number: 'D017.13', title: 'Other' },
					].map(item => {
						return <>
							<div className='development-customer df aic jcsb mt2rem w70'>
								<div className='left-area mr2rem '>
									<p>{item['number']} <b>{item['title']}</b></p>
									<div className="pr df mt1rem">
										<input type="url" placeholder="Web site url" className="bg5 w100 br30px bw1px bo16 bss py0-5rem px1rem mr1rem" />
										<input type="email" placeholder="Email of contact" className="bg5 w100 br30px bw1px bo16 bss py0-5rem px1rem" />
									</div>
								</div>
								<label for="Accountants" className="py0-5rem df cp mb0-5rem label-checkbox">
									<span className="checkbox w2rem h2rem pr">
										<input name="Accountants1" id="Accountants" className="bg5 bo16 bw1px bss cp td250 w2rem h2rem br5px" type="radio" />
									</span>
								</label>
							</div>
							<hr style={{ border: "none", height: "1px", display: "block", width: "70%", marginTop: "18px", backgroundColor: "#002d6340" }} />
						</>
					})}
				</div>
			</div>
		)
	};

	return (
		<AnimatedPage>
			<div className="td250 container bg1 py1rem shadow w100 df company-settings-page">
				<div className="w80 mr1rem gg1rem mt1rem">
					<div className="tac ttc df fdc jcc aic">
						<h1 className="w100 c14 fs2rem lh2">{tabIndex}</h1>
						{tabIndex == "Companies House Core Info" &&
							<button onClick={() => {
								if (getCompany) getCompany(); else fetchCompany();
							}} className='cp tac c1 bg3 bg4-hover br20px px2rem py0-5rem fw500 mt1rem'>Refresh</button>
						}
					</div>
					{company && tabIndex == "Companies House Core Info" && <>{companiesHouseCore()}</>}
					{company && tabIndex == "Group Info" && <>{groupInfo()}</>}
					{company && tabIndex == "Company Profile" && <>{companyProfile()}</>}
					{company && tabIndex == "Director's Info" && <>{directorsInfo()}</>}
					{company && tabIndex == "Direct/Indirect Channel" && <>{directIndirectChannel()}</>}
					{company && tabIndex == "Company Stage Of Development" && <>{companyStageofDevelopment()}</>}
					{company && tabIndex == "Company Objectives" && <>{companyObjectives()}</>}
					{company && tabIndex == "Subscription Model Info" && <>{subscriptionModelInfo()}</>}
					{/* {company && tabIndex == "User Permissions" && <>{userPermissions()}</>} */}
					{company && tabIndex == "Advisor Permissions" && <>{advisorPermissions()}</>}
				</div>
				{getSidebarHTML()}
			</div>

			{/* Filing Read More */}
			<Modal open={modal['open'] == 'filingReadMore'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr">
					<div className='avtar-area df jcc'>
						<img className="h2rem" src={require(`../../../../images/filinghistory.png`)} alt="" />
					</div>
					<h3 className='mt1rem text-gradient fs1-5rem tac'>Filing History</h3>
					<button className="close-popup" onClick={() => { dispatch(toggleModal({ open: '' })); setFilingReadMore({}) }}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<div className='group-inputs mt1rem'>
						<p className='my1rem ttc'><b>Category:</b> {filingReadMore['category'] ? filingReadMore['category'] : '-'}</p>
						<p className='my1rem ttc'><b>Description:</b> {filingReadMore['description'] ? filingReadMore['description'] : '-'}</p>
						<p className='my1rem ttc'><b>Bar Code:</b> {filingReadMore['barcode'] ? filingReadMore['barcode'] : '-'}</p>
						<p className='my1rem ttc'><b>Transaction Id:</b> {filingReadMore['transaction_id'] ? filingReadMore['transaction_id'] : '-'}</p>
						<p className='my1rem ttc'><b>Date:</b> {filingReadMore['date'] ? filingReadMore['date'] : '-'}</p>
						<p className='my1rem ttc'><b>Document:</b> {filingReadMore['Location'] ? <a href={filingReadMore['Location']} target='_blank' className='tdu ttu'>View Document</a> : '-'}</p>
					</div>
				</div>
			</Modal>

			{/* Officers Read More */}
			<Modal open={modal['open'] == 'officersReadMore'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr">
					<div className='avtar-area df jcc'>
						<img className="h2rem" src={require(`../../../../images/officersavatar.png`)} alt="" />
					</div>
					<h3 className='mt1rem text-gradient fs1-5rem tac'>Officers</h3>
					<button className="close-popup" onClick={() => { dispatch(toggleModal({ open: '' })); setOfficersReadMore({}) }}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<div className='group-inputs mt1rem'>
						<p className='my1rem ttc'><b>Name:</b>  {officersReadMore['name'] ? officersReadMore['name'] : '-'}</p>
						<p className='my1rem ttc'><b>Role:</b>  {officersReadMore['officer_role'] ? officersReadMore['officer_role'] : '-'}</p>
						<p className='my1rem ttc'><b>Address:</b> {officersReadMore['address']
							? <>{officersReadMore['address']['premises'] && officersReadMore['address']['premises']}
								{officersReadMore['address']['address_line_1'] && ', ' + officersReadMore['address']['address_line_1']}
								{officersReadMore['address']['address_line_2'] && ', ' + officersReadMore['address']['address_line_2']}
								{officersReadMore['address']['locality'] && ' - ' + officersReadMore['address']['locality']}
								{officersReadMore['address']['region'] && ', ' + officersReadMore['address']['region']}
								{officersReadMore['address']['country'] && ', ' + officersReadMore['address']['country']}
							</>
							: '-'
						}</p>
						<p className='my1rem ttc'><b>Nationality:</b>  {officersReadMore['nationality'] ? officersReadMore['nationality'] : '-'}</p>
						<p className='my1rem ttc'><b>Occupation:</b>  {officersReadMore['occupation'] ? officersReadMore['occupation'] : '-'}</p>
						<p className='my1rem ttc'><b>DOB:</b>  {officersReadMore['date_of_birth'] ? officersReadMore['date_of_birth']['month'] + '/' + officersReadMore['date_of_birth']['year'] : '-'}</p>
					</div>
				</div>
			</Modal>

			{/* Controls Read More */}
			<Modal open={modal['open'] == 'controlReadMore'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr">
					<div className='avtar-area df jcc'>
						<img className="h2rem" src={require(`../../../../images/officersavatar.png`)} alt="" />
					</div>
					<h3 className='mt1rem text-gradient fs1-5rem tac'>Persons with Significant Control</h3>
					<button className="close-popup" onClick={() => { dispatch(toggleModal({ open: '' })); setControlReadMore({}) }}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<div className='group-inputs mt1rem'>
						<p className='my1rem ttc'><b>Name:</b>  {controlReadMore['name'] ? controlReadMore['name'] : '-'}</p>
						<p className='my1rem ttc'><b>Controls:</b>
							{controlReadMore['natures_of_control'] && controlReadMore['natures_of_control'].length > 0
								? <>{controlReadMore['natures_of_control'].map((control, idx) => (
									<ul key={idx}><li>{control}</li></ul>
								))}</>
								: '-'}</p>
						<p className='my1rem ttc'><b>E-Tag:</b>  {controlReadMore['etag'] ? controlReadMore['etag'] : '-'}</p>
						<p className='my1rem ttc'><b>Notified Date:</b>  {controlReadMore['notified_on'] ? controlReadMore['notified_on'] : '-'}</p>
						<p className='my1rem ttc'><b>Address:</b> {controlReadMore['address']
							? <>{controlReadMore['address']['premises'] && controlReadMore['address']['premises']}
								{controlReadMore['address']['address_line_1'] && ', ' + controlReadMore['address']['address_line_1']}
								{controlReadMore['address']['address_line_2'] && ', ' + controlReadMore['address']['address_line_2']}
								{controlReadMore['address']['locality'] && ' - ' + controlReadMore['address']['locality']}
								{controlReadMore['address']['region'] && ', ' + controlReadMore['address']['region']}
								{controlReadMore['address']['country'] && ', ' + controlReadMore['address']['country']}
							</>
							: '-'
						}</p>
						<p className='my1rem ttc'><b>Nationality:</b>  {controlReadMore['nationality'] ? controlReadMore['nationality'] : '-'}</p>
						<p className='my1rem ttc'><b>DOB:</b>  {controlReadMore['date_of_birth'] ? controlReadMore['date_of_birth']['month'] + '/' + controlReadMore['date_of_birth']['year'] : '-'}</p>
					</div>
				</div>
			</Modal>

			{/* Charge Read More */}
			<Modal open={modal['open'] == 'chargeReadMore'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 px3rem py2rem bsbb df fdc m1rem maw600px br5px pr">
					<div className='avtar-area df jcc'>
						<img className="h2rem" src={require(`../../../../images/officersavatar.png`)} alt="" />
					</div>
					<h3 className='mt1rem text-gradient fs1-5rem tac'>Charges</h3>
					<button className="close-popup" onClick={() => { dispatch(toggleModal({ open: '' })); setChargeReadMore({}) }}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<div className='group-inputs mt1rem'>
						<p className='my1rem ttc'><b>Persons Entitled:</b>  {chargeReadMore['persons_entitled'] ? chargeReadMore['persons_entitled'][0]['name'] : '-'}</p>
						<p className='my1rem ttc'><b>Charge Description:</b>  {chargeReadMore['classification'] ? chargeReadMore?.['classification']?.['description'] : '-'}</p>
						<p className='my1rem ttc'><b>Status:</b>  {chargeReadMore['status'] ? chargeReadMore['status'] : '-'}</p>
						<p className='my1rem ttc'><b>E-Tag:</b>  {chargeReadMore['etag'] ? chargeReadMore['etag'] : '-'}</p>
						<p className='my1rem ttc'><b>Charge Number:</b>  {chargeReadMore['charge_number'] ? chargeReadMore['charge_number'] : '-'}</p>
						<p className='my1rem ttc'><b>Delivered On:</b>  {chargeReadMore['delivered_on'] ? chargeReadMore['delivered_on'] : '-'}</p>
						<p className='my1rem ttc'><b>Satisfied On:</b>  {chargeReadMore['satisfied_on'] ? chargeReadMore['satisfied_on'] : '-'}</p>
						<p className='my1rem ttc'><b>Short Particulars:</b>  {chargeReadMore['particulars'] ? chargeReadMore?.['particulars']?.['description'] : '-'}</p>
						<p className='my1rem ttc'><b>Amount secured description:</b>  {chargeReadMore['secured_details'] ? chargeReadMore?.['secured_details']?.['description'] : '-'}</p>
						<p className='my1rem ttc'><b>Transaction filing type:</b>  {chargeReadMore['transactions'] ? chargeReadMore?.['transactions']?.['filing_type'] : '-'}</p>
						<p className='my1rem ttc'><b>Transaction filing Delivered On:</b>  {chargeReadMore['transactions'] ? chargeReadMore?.['transactions']?.['delivered_on'] : '-'}</p>
					</div>
				</div>
			</Modal>

			{/* Upload CV Data */}
			<Modal open={modal['open'] == 'uploadCvData'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw600px br5px pr">
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => closeDirectorPopup()}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs1-25rem fw600 mt1rem">Director Info Update</h1>
					<div className='group-inputs mt2rem'>
						<h3 className='fs1rem fw500 mb1rem'>Upload CV Here</h3>
						<label for="fileUpload" className="w100 bsbb bg5 br5px df jcc aic p1rem bsd bo6 bw2px cp">
							<span className="pen fs1rem fw500 tac">Upload CV</span>
							<input onChange={handleCvChange} className="dn" id="fileUpload" type="file" multiple />
						</label>
						{cvData[director['_id']] && <div className="df fww mt0-5rem">
							{cvData[director['_id']] && <a className="df jcc aic br25px lh1 bg3 c1 px0-5rem fw600 mr0-5rem mb0-5rem" target="_blank" href={cvData[director['_id']]?.location}>
								<span className="py0-5rem px0-5rem">{cvData[director['_id']]?.name}</span>
							</a>}
						</div>}
						<p className='fs1rem fw500 mt1rem mb0-5rem'>LinkedIn Profile</p><br />
						<input id="LinkedinUrl" name="LinkedinUrl" type="url" placeholder="Please add LinkedIn url" value={formData['linkedIn'] || ''} onChange={(e) => setFormData({ ...formData, linkedIn: e.target.value })}
							className="w100 show-input shadow bg5 br5px p1rem mb1rem" />

						<div className='df jcse'>
							<span onClick={() => handleSubmit()} className="shadow bg3 bg4-hover c1 td250 br5px px2rem py0-5rem cp ttu mr1rem bsbb tac df jcc aic mt1rem">Submit</span>
						</div>
					</div>
				</div>
			</Modal>

			{/* Delete File */}
			<Modal open={modal['open'] == 'deleteFiles'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 oya bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px br5px pr">
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs2rem fw600 my1rem">Delete File</h1>
					<h2 className="c4 fs1rem fs1-5rem-sm ttu w100 tac mb1rem">Are you sure you want to delete this file?</h2>
					<p className="fs1-25rem fw500 mb1rem">{attachment && attachment.originalname}</p>
					<span onClick={() => confirmDeleteFiles()} className="shadow bg3 bg4-hover c1 td250 br5px p1rem fw600 cp ttu w100 bsbb tac mb1rem df jcc aic">Delete File</span>
					<span onClick={() => dispatch(toggleModal({ open: '' }))} className="c3-hover td250 fs1-25rem cp">Cancel</span>
				</div>
			</Modal>

			{/* Delete Company */}
			<Modal open={modal['open'] == 'companyDelete'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h3 className="company-name fs1-25rem c15">{company?.['cName']}</h3>
					<img className="h2rem pa t0 l0 m1rem" src={require(`../../../../images/logo.svg`)} alt="TODO" />
					<div className='df jcc'>
						<button onClick={() => dispatch(toggleModal({ open: 'deleteAuditLog' }))} className='pa r0 cp tac c1 bg3 bg4-hover br5px shadow px1rem py0-5rem mr3rem fw500'>Audit Log</button>
						<h1 className="text-gradient fw600 pb1rem">Delete Company</h1>
					</div>
					<div className="tac my1rem">
						<p>Are you certain you want to delete that <b>{company?.['cName']}</b> Company?</p>
					</div>
					<div className="df jcse">
						<button onClick={() => dispatch(toggleModal({ open: '' }))} className="h100 mt0-5rem shadow bg4 bg3-hover c1 td250 br5px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">Cancel</button>
						<button onClick={() => submitDeleteCompany()} className="h100 mt0-5rem shadow bg3 bg4-hover c1 td250 br5px px2rem fs0-75rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">Submit</button>
					</div>
				</div>
			</Modal>

			{/* Add Group Company */}
			<Modal open={modal['open'] == 'addGroupCompany'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="mah90 mih35 bg1 shadow w100 p2rem bsbb df fdc m1rem maw700px br5px pr">
					<button className="close-popup" onClick={() => { dispatch(toggleModal({ open: '' })); setCompaniesGroup({}) }}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs2rem tac lh1 fw600 mb2rem">Add Group Company</h1>
					<div className='bottom-company-area'>
						{companies && companies.map((childCompnay, idx) => {
							if (childCompnay['_id'] !== company?.['_id'] && childCompnay['group'] !== "Parent") {
								return (
									<div key={idx} className='company-detail-box df aic w95'>
										<span className="checkbox active w2rem h2rem pr mr1rem">
											<input onChange={(event) => handleChildCompany({ event, companyId: childCompnay['_id'], group: companiesGroup[childCompnay['_id']]?.['group'], selected: 'true' })}
												id={`childCompnay-${childCompnay['_id']}`}
												className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px"
												type="checkbox"
											/>
										</span>
										<div className="company-detail df fww p1rem br10px shadow bg1 fs1rem mb1rem w100 aic">
											<h4 className='fs0-75rem mr1rem w9rem'>{childCompnay['cName']}</h4>
											<span className='mr0-5rem df jsc w6rem'>
												<h2 className="fs1rem c7 mra tal mr0-5rem w4rem">
													{childCompnay['subscription']
														? childCompnay['subscription']?.toUpperCase()
														: 'INACTIVE'
													}
												</h2>
												<div className='df'>
													<span className='w30 df username-area'>
														<div className="df aic">
															<span className="ass fs0-75rem mt0-3rem ml0-5rem mr0-2rem">Owner</span>
															<span onClick={() => dispatch(toggleModal({ open: 'userDetail' }))} data-tooltip={user?.firstName ? (user?.firstName + " " + user?.lastName) : "Register to show your name here"} className="w2rem h2rem df jcc aic br100 bg3 c1 mr0-5rem fs0-75rem">{user?.firstName ? (user?.firstName?.[0] + user?.lastName?.[0]) : "?"}</span>
														</div>
													</span>
												</div>
											</span>
											<div className='dropdown-company w4rem px1rem py0-5rem ml1rem'>
												<select value={companiesGroup[childCompnay['_id']]?.['group']} name="dropdown" className="fs0-75rem" onChange={(e) => handleChildCompany({ companyId: childCompnay['_id'], group: e.target.value })} id={`group-${childCompnay['_id']}`}>
													<option value='Subsidiary'>Subsidiary</option>
													<option value='Associate'>Associate</option>
												</select>
											</div>
											<div className='percentage-area ml1rem w7rem'>
												<span className='input-area'>
													<input onChange={(e) => handleChildCompany({ companyId: childCompnay['_id'], group: companiesGroup[childCompnay['_id']]?.['group'], percentage: e.target.value })} placeholder='Enter Percentage %' id={`percentage-${childCompnay['_id']}`} type="text" className="fw600" min="1" max="100" />
												</span>
											</div>
										</div>
									</div>
								)
							}
						})}
					</div>
					<span onClick={updateGroupCompany} id="createGroup" className={`${(company == null || companiesGroup.length == 0) && 'op20 pen '} mt0-5rem shadow bg3 bg4-hover c1 td250 br5px pt0-5rem pb0-5rem pl3rem pr3rem fw600 cp ttu bsbb tac df jcc aic`}>Add</span>
				</div>
			</Modal>

			{/* Edit/Delete Group Company */}
			<Modal open={modal['open'] == 'updateGroupCompany'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="mah90 mih35 bg1 shadow w100 p2rem bsbb df fdc m1rem maw700px br5px pr">
					<button className="close-popup" onClick={() => { dispatch(toggleModal({ open: '' })), setCompaniesGroup({}) }}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs2rem tac lh1 fw600 mb2rem">{updateType} Group Company</h1>
					<div className='bottom-company-area'>
						{company && company?.['childrenCompanies'] && company?.['childrenCompanies'].map((childCompnay, idx) => {
							return (
								<div key={idx} className='company-detail-box df aic w95'>
									<span className="checkbox active w2rem h2rem pr mr1rem">
										<input onChange={(event) => handleChildCompany({ event, companyId: childCompnay['_id'], group: childCompnay['group'], percentage: childCompnay['percentage'], selected: 'true' })}
											id={`childCompnay${childCompnay['_id']}`}
											className="bg5 shadow bo5 bw2px bss cp td250 w2rem h2rem br5px"
											type="checkbox"
										/>
									</span>
									<div className="company-detail df fww p1rem br10px shadow bg1 fs1rem mb1rem w100 aic">
										<h4 className='fs0-75rem mr1rem w9rem'>{childCompnay['cName']}</h4>
										<span className='mr0-5rem df jsc w6rem'>
											<h2 className="fs1rem c7 mra tal mr0-5rem w4rem">
												{childCompnay['subscription']
													? childCompnay['subscription']?.toUpperCase()
													: 'INACTIVE'
												}
											</h2>
											<div className='df'>
												<span className='w30 df username-area'>
													<div className="df aic">
														<span className="ass fs0-75rem mt0-3rem ml0-5rem mr0-2rem">Owner</span>
														<span onClick={() => dispatch(toggleModal({ open: 'userDetail' }))} data-tooltip={user?.firstName ? (user?.firstName + " " + user?.lastName) : "Register to show your name here"} className="w2rem h2rem df jcc aic br100 bg3 c1 mr0-5rem fs0-75rem">{user?.firstName ? (user?.firstName?.[0] + user?.lastName?.[0]) : "?"}</span>
													</div>
												</span>
											</div>
										</span>
										<div className='dropdown-company w4rem px1rem py0-5rem ml1rem'>
											<select defaultValue={childCompnay['group']} disabled={updateType == "Delete"} name="dropdown" className="fs0-75rem" onChange={(e) => handleChildCompany({ companyId: childCompnay['_id'], group: e.target.value })} id={`group-${childCompnay['_id']}`}>
												<option value='Subsidiary'>Subsidiary</option>
												<option value='Associate'>Associate</option>
											</select>
										</div>
										<div className='percentage-area ml1rem w7rem'>
											<span className='input-area'>
												<input defaultValue={childCompnay['percentage']} disabled={updateType == "Delete"} onChange={(e) => handleChildCompany({ companyId: childCompnay['_id'], percentage: e.target.value })}
													placeholder='Enter Percentage %' id={`percentage-${childCompnay['_id']}`} type="text" className="fw600" min="1" max="100" style={{ color: updateType == 'Delete' && '#aeacac' }} />
											</span>
										</div>
									</div>
								</div>
							)
						})}
					</div>
					<span onClick={() => updateGroupCompany()} id="createGroup" className={`${(company == null || companiesGroup.length == 0) && 'op20 pen '} mt0-5rem shadow bg3 bg4-hover c1 td250 br5px pt0-5rem pb0-5rem pl3rem pr3rem fw600 cp ttu bsbb tac df jcc aic`}>{updateType}</span>
				</div>
			</Modal>

			{/* User Permissions Logs */}
			<Modal open={modal['open'] == 'permissionsLogs'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs1-5rem fw600 tac">{company?.['cName']} User Permission Log</h1>
					<h2 className="c4 fs0-75rem ttu w100 tac mb1rem">See the history of User Permissions</h2>
					<div className="ma oya dg gg0-5rem mb2rem w100">
						{permissionLogList && permissionLogList.length > 0
							? permissionLogList.map(log => {
								return (
									<div className="df my0-5rem">
										{log?.['userId']?.['profile']
											&& <img className={`ass ml0-5rem br100 w2rem h2rem ${profileClass}`} src={log['userId']['profile']} data-tooltip={log?.['userId'].firstName ? (log?.['userId'].firstName + " " + log?.['userId'].lastName) : "Register to show your name here"} />
											|| <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 bw1px bss bo16 fs0-75rem ${profileClass}`}>{log?.['userId']?.['firstName']?.[0] || "?"}{log?.['userId']?.['lastName']?.[0] || "?"}</span>
										}
										<div className="w100">
											<span className='fs0-75rem ml1rem'><b>{log['message']}</b> at <b>{new Date(log.timestamp).toLocaleString()}</b></span>
											{(log?.['endpoint']?.includes('newMember') || log?.['endpoint']?.includes('editMember')) ? (
												<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
													<p><b>First Name:</b> {log?.['payload']?.['firstName']}</p>
													<p><b>Last Name:</b> {log?.['payload']?.['lastName']}</p>
													<p><b>Email:</b> {log?.['payload']?.['email']}</p>
													<p><b>Designation:</b> {log?.['payload']?.['designation']}</p>
												</div>
											) : log?.['endpoint']?.includes('updatePermission') ? (
												<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
													<b>Changed Permission:</b>
													<p><b>{log?.['payload']?.['sectionNo']}</b> - ({permissionNames[log?.['payload']?.['sectionNo']]})
														permission is {log?.['payload']?.['action'] ? 'added to' : 'removed from'}
														<b> {log?.['payload']?.['member']?.['firstName']}</b> - ({log?.['payload']?.['member']?.['designation']})
													</p>
												</div>
											) : ''}
										</div>
									</div>
								)
							})
							: <h2 className="c4 fs1-50rem ttu w100 tac mb1rem">No Logs Found!!</h2>
						}
					</div>
				</div>
			</Modal>

			{/* Audit Logs */}
			<Modal open={modal['open'] == 'auditLogs'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs1-5rem fw600 tac ttu">{company?.['cName']} Company Audit Log</h1>
					<h2 className="c4 fs0-75rem ttu w100 tac mb1rem">See the history of Company Audit Updated</h2>
					<div className="ma oya dg gg0-5rem mb2rem w100">
						<div className='df'>
							{company?.['creatorId']?.['profile']
								&& <img className={`ass ml0-5rem br100 w2rem h2rem ${profileClass}`} src={company?.['creatorId']['profile']} data-tooltip={company?.['creatorId']?.['firstName'] ? (company?.['creatorId']?.['firstName'] + " " + company?.['creatorId']?.['lastName']) : "Register to show your name here"} />
								|| <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 fs0-75rem ${profileClass}`}>{company?.['creatorId']?.['firstName']?.[0] || "?"}{company?.['creatorId']?.['lastName']?.[0] || "?"}</span>
							}
							<span className='fs0-75rem ml1rem'><b>Company details updates</b></span>
						</div>
						<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
							<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Name:</span> {company?.['cName']}</p>
							{company?.['creatorId'] && <p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Owner:</span> {company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']?.['lastName']}</p>}
							<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Created At:</span> {moment(company?.['creaedAt']).format('ll')}</p>
							<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Payment Source:</span> {company?.['paymentSource']}</p>
							<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Stage of development:</span> {company?.['cStage']}</p>
							<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Objectives:</span> {company?.['testType']}</p>
							<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Subscription:</span>
								{((company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company?.['subscription'] == 'Pro')
									? 'Portfolio PRO'
									: <>{company?.['subscription']}</>
								}
							</p>
						</div>
						{auditLogList && auditLogList.length > 0 && auditLogList.map(log => {
							return (
								<div className="df my0-5rem">
									{log?.['userId']?.['profile']
										&& <img className={`ass ml0-5rem br100 w2rem h2rem ${profileClass}`} src={log['userId']['profile']} data-tooltip={log?.['userId'].firstName ? (log?.['userId'].firstName + " " + log?.['userId'].lastName) : "Register to show your name here"} />
										|| <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 bw1px bss bo16 fs0-75rem ${profileClass}`}>{log?.['userId']?.['firstName']?.[0] || "?"}{log?.['userId']?.['lastName']?.[0] || "?"}</span>
									}
									<div className="w100">
										<span className='fs0-75rem ml1rem'><b>{log['message']}</b> at <b>{new Date(log.timestamp).toLocaleString()}</b> by <b>{log?.['userId']?.['firstName']} {log?.['userId']?.['lastName']}</b></span>
										{/* Company Info Logs */}
										{log['payload']['update'] &&
											<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
												<p className="df fw500 fs1rem">Changes to {company?.['cName']} - Company Details:</p>
												<div className="df w100">
													<div className="mr0-5rem">
														{Object.keys(log['payload']['update']).map(key => {
															return <p className="fw600">{companyKeys[key]}:</p>
														})}
													</div>
													<div>
														{Object.values(log['payload']['update']).map(value => {
															return <p>{value}</p>
														})}
													</div>
												</div>
											</div>
										}
										{/* Company Group Logs */}
										{log['payload']?.['data']?.['childUpdates'] && log['payload']?.['data']?.['childUpdates'].length > 0 &&
											<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
												<p className="df fw500 fs1rem">{log['payload']['data']['type'] && log['payload']['data']['type']} Group Info:</p>
												{log['payload']?.['data']?.['childUpdates'].map(data => {
													return <>
														{companies && companies.length > 0 && companies.map(company => {
															if (company?.['_id'] == log['payload']?.['data']?.['parentId']) {
																if (company?.['childrenCompanies']) {
																	for (let childCompnay of company?.['childrenCompanies']) {
																		if (childCompnay['_id'] == data['companyId']) {
																			return <p><span className='fw600'>Company Name:</span> {childCompnay['cName']}</p>
																		}
																	}
																}
															}
														})}
														<p><span className='fw600'>Group:</span> {data['group']}</p>
														<p><span className='fw600'>Percentage:</span> {data['percentage']}%</p>
													</>
												})}
											</div>
										}
										{/* Company Directors Logs */}
										{log['payload']['directorId'] &&
											<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
												<p className="df fw500 fs1rem">Changes to {log['payload']['directorId']['name']} - Director's Info:</p>
												<p className='df fw500'><span className='fw600 mr0-5rem'>CV:</span>
													{log['files'].length > 0 && log['files'].map(file => (
														<a className="fw400 mr0-5rem fs0-75rem tdu" target="_blank" href={file?.location}><span>{file?.originalname}</span></a>
													))}
												</p>
												<p className='df fw500'><span className='fw600 mr0-5rem'>LinkedIn:</span>
													{log['payload']['linkedIn'] && log['payload']['linkedIn'] !== 'undefined'
														? <a className="fw400 mr0-5rem fs0-75rem tdu" target="_blank" href={log['payload']['linkedIn']}>{log['payload']['linkedIn']}</a> : '-'}
												</p>
											</div>
										}
									</div>
								</div>
							)
						})
						}
					</div>
				</div>
			</Modal>

			{/* Company Audit Logs */}
			<Modal open={modal['open'] == 'companyAuditLog'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs1-5rem fw600 tac ttu">{company?.['cName']} - {tabIndex} Log</h1>
					<h2 className="c4 fs0-75rem ttu w100 tac mb1rem">See the history of {tabIndex} Updates</h2>
					<div className="ma oya dg gg0-5rem mb2rem w100">
						<div className="df my0-5rem">
							{company?.['creatorId']?.['profile']
								&& <img className={`ass ml0-5rem br100 w2rem h2rem ${profileClass}`} src={company?.['creatorId']['profile']} data-tooltip={company?.['creatorId'].firstName ? (company?.['creatorId'].firstName + " " + company?.['creatorId'].lastName) : "Register to show your name here"} />
								|| <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 bw1px bss bo16 fs0-75rem ${profileClass}`}>{company?.['creatorId']?.['firstName']?.[0] || "?"}{company?.['creatorId']?.['lastName']?.[0] || "?"}</span>
							}
							<div className="w100">
								<span className='fs0-75rem ml1rem'><b>{tabIndex} Updated</b> at <b>{new Date(company?.createdAt).toLocaleString()}</b> {company?.['creatorId'] && <> by <b>{company?.['creatorId']['firstName']} {company?.['creatorId']['lastName']}</b></>}</span>
								<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
									<p className="df fw500 fs1rem mb0-5rem">{tabIndex} Info:</p>
									{tabIndex == "Direct/Indirect Channel" && <>
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Name:</span> {company?.['cName']}</p>
										{company?.['creatorId'] && <p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Owner:</span> {company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']['lastName']}</p>}
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Created At:</span> {moment(company?.['creaedAt']).format('ll')}</p>
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Type of customer:</span> {company?.['customerType']}</p>
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Payment Source:</span> {company?.['paymentSource']}</p>
									</>}
									{tabIndex == "Company Stage Of Development" && <>
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Name:</span> {company?.['cName']}</p>
										{company?.['creatorId'] && <p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Owner:</span> {company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']['lastName']}</p>}
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Created At:</span> {moment(company?.['creaedAt']).format('ll')}</p>
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Stage of development:</span> {company?.['cStage']}</p>
									</>}
									{tabIndex == "Company Objectives" && <>
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Name:</span> {company?.['cName']}</p>
										{company?.['creatorId'] && <p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Owner:</span> {company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']['lastName']}</p>}
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Created At:</span> {moment(company?.['creaedAt']).format('ll')}</p>
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Objectives:</span> {company?.['testType']}</p>
									</>}
									{tabIndex == "Subscription Model Info" && <>
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Name:</span> {company?.['cName']}</p>
										{company?.['creatorId'] && <p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Owner:</span> {company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']['lastName']}</p>}
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Created At:</span> {moment(company?.['creaedAt']).format('ll')}</p>
										<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Subscription:</span>
											{((company?.['creatorId']?.['createdBy']?.['role'] == 'Advisor' || company?.['creatorId']?.['createdBy']?.['role'] == 'Investor') && company?.['subscription'] == 'Pro')
												? 'Portfolio PRO'
												: <>{company?.['subscription']}</>
											}
										</p>
										{company?.['expensions'] && Object.keys(company?.['expensions']).length > 0 && <>
											<p className="df fw500 fs1rem my0-5rem">Expansion Info:</p>
											{company?.['expensions']['DEPN004'] && <li>DEPN004 – Industry Expansion Pack – Software Development {isNaN(company?.['expensions']['DEPN004']) && <> - {moment(company?.['expensions']['DEPN004']).format('ll')}</>}</li>}
											{company?.['expensions']['DEPF005'] && <li>DEPF005 – Function Expansion Pack - Environmental Social & Governmental (ESG) {isNaN(company?.['expensions']['DEPF005']) && <> - {moment(company?.['expensions']['DEPF005']).format('ll')}</>}</li>}
											{company?.['expensions']['DEPF006'] && <li>DEPF006 – Function Expansion Pack – Warranty Disclosure Schedule {isNaN(company?.['expensions']['DEPF006']) && <> - {moment(company?.['expensions']['DEPF006']).format('ll')}</>}</li>}
											{company?.['expensions']['DEPF007'] && <li>DEPF007 – Expansion Pack – DD – Directors Questionnaire {isNaN(company?.['expensions']['DEPF007']) && <> - {moment(company?.['expensions']['DEPF007']).format('ll')}</>}</li>}
										</>}
									</>}
								</div>
							</div>
						</div>
					</div>
				</div>
			</Modal>

			<Modal open={modal['open'] == 'editUser'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="bg1 shadow w100  bsbb df fdc m1rem maw600px br10px">
					<div className='top-header py1rem px2rem df jcsb aic' style={{ backgroundColor: '#CBD3F980', borderRadius: '8px 8px 0 0' }}>
						<h4 className='fs1-5rem c15 fw500 ttc'>{userAction} User</h4>
						<img className="w60px" src={require(`../../../../images/logo-icon.svg`)} alt="TODO" />
					</div>
					<div className="df fdc gg1rem px3rem py2rem mah600px oya advisor-box-content">
						{userAction === 'Search'
							? <div className="df fdc gg1rem">
								<div className="pr">
									<input id="searchEmail" name="searchEmail" type="email" placeholder="Search Email" className="pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem" />
									<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 512 512">
										<path d="M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z" className="fa-secondary"></path>
										<path d="M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z" className="fa-primary"></path>
									</svg>
								</div>
								<span id='NewUserStep' onClick={findUser} className="new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem">
									Search User
								</span>
							</div>
							: <div className="df fdc gg1rem">
								<div className="pr">
									<input id="userFirstName" name="firstName" type="text" placeholder="First Name" onChange={handleUserChange} value={editUser['firstName'] || ""}
										className="pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem" />
									<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 640 512">
										<path d="M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z" className="fa-secondary"></path>
									</svg>
								</div>
								<div className="pr">
									<input id="userLastName" name="lastName" type="text" placeholder="Last Name" onChange={handleUserChange} value={editUser['lastName'] || ""}
										className="pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem" />
									<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 640 512">
										<path d="M639.77 208.21v32.1c0 8.5-6.7 15.1-15.2 15.8-39.4 3.2-105.4 51-138.4 65.8-34.3 15.4-66.7 30-102.3 30-28.2 0-50.2-8.5-65.5-25.3-22.7-24.9-22.8-55.3-20.6-83.8-56.5 45.1-169 153.6-211.2 195.8A31.63 31.63 0 0 1 64 448c-27 0-36.5-27-29.7-43.9l98.2-245.6c8-19.9-14.3-38.8-32.7-27.1l-58 38.9a15.91 15.91 0 0 1-22.1-4.9l-17.2-27a16.08 16.08 0 0 1 4.9-22.1l54.9-36.9c76.5-48.7 160.1 26.9 129.7 102.8l-41.5 103.7c105.2-101.2 144.4-124.5 169.5-126 54.4-3.1 43.8 68.1 42.7 76.1-4.7 35.7-1.3 51.9 21.3 51.9 21.9 0 47-11.3 76.1-24.4 37.4-16.8 111.3-68 163.1-71.5 9.07-.59 16.8 7.11 16.57 16.21z" className="fa-secondary"></path>
									</svg>
								</div>
								<div className="pr">
									<input id="userEmail" name="email" type="email" placeholder="Email" onChange={handleUserChange} value={editUser['email'] || ""} disabled={userAction == 'Edit' || userAction == 'Add' ? true : false}
										className="pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem" />
									<svg className="center-vertically f3 pa l0 ml1rem w2rem" viewBox="0 0 512 512">
										<path d="M256.47 352h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V400a48 48 0 0 0 48 48h416a48 48 0 0 0 48-48V183.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52zM464 64H48a48 48 0 0 0-48 48v19a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4 41.4 23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131v-19a48 48 0 0 0-48-48z" className="fa-secondary"></path>
										<path d="M512 131v52.36c-24.46 19.17-169.4 125.34-173 128.12-22.12 17.1-52.43 40.52-82.53 40.52h-.94c-30.1 0-60.41-23.42-82.54-40.52C169.39 308.7 24.77 202.7 0 183.33V131a24.08 24.08 0 0 0 9.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.69 12.12 49.75 41.4 72.93 41.4h.94c23.18 0 56.24-29.28 72.93-41.4 132.7-96.3 142.8-104.7 173.4-128.7A23.93 23.93 0 0 0 512 131z" className="fa-primary"></path>
									</svg>
								</div>
								<div className="pr">
									<input id="designation" name="designation" type="text" placeholder="Job Title" className="pl4rem bg1 w100 br10px p1rem bss bo16 bw1px c15 fs1rem" onChange={handleUserChange} value={editUser['designation'] || ""} />
									<svg className="center-vertically f3 pa l0 ml1rem w2rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path className="fa-primary" d="M133.3 308.8C56.91 326.9 0 395.4 0 477.3C0 496.5 15.52 512 34.66 512H184L133.3 308.8zM314.7 308.8L264 512h149.3C432.5 512 448 496.5 448 477.3C448 395.4 391.1 326.9 314.7 308.8z" /><path className="fa-secondary" d="M176 288l32 56l-31.99 135.1L184 512h80l7.988-32.05L240 344l32-56H176zM224 0C153.3 0 96 57.25 96 128s57.25 128 128 128s128-57.25 128-128S294.8 0 224 0z" /></svg>
								</div>
								<h2 className="c15 fs1-25rem ttu w100 tal 0 mb0-5rem">Permissions</h2>
								<div id="userPermissions" className="dg gg0-5rem my1rem">
									<div className="tac df jcfs">
										<span className="checkbox w30px h30px pr mr1rem">
											<input onChange={selectAllPermissions} className="bg1 new-shadow bo5 bw2px bss cp td250 w30px h30px br5px"
												type="checkbox" checked={selectAll} />
										</span>
										<span className="fs1rem c15 fw600 mr1rem usn">All Permissions</span>

									</div>
									{company?.['sections'] && company?.['sections'].map((section, idx) => {
										return (
											<label key={idx} for={"permissions" + section['sectionNo']} className="df cp fs1rem">
												<span className="checkbox w30px h30px pr mr1rem">
													<input
														type="checkbox"
														onChange={changeUser}
														name={section['sectionNo']}
														id={"permissions" + section['sectionNo']}
														className="bg1 new-shadow bo5 bw2px bss cp td250 w30px h30px br5px"
														checked={editUser.permissions && editUser.permissions[section['sectionNo']]}
													/></span>
												<span className="fs1rem fw600 mr1rem usn c15">{section['sectionNo']}</span>
												<span className="fs1rem fw400 usn c15">{section['sectionName']}</span>
											</label>
										)
									})}
								</div>
								<span onClick={() => saveUser()} className="new-shadow bg3 bg4-hover c1 td250 br25px p1rem fw600 cp ttu bsbb tac df jcc aic px3rem mt1rem">Save</span>
								<span onClick={() => dispatch(toggleModal({ open: '' }))} className="c3-hover td250 fs1-25rem cp">Cancel</span>
							</div>
						}
					</div>
					<svg className="pa cp" onClick={() => { dispatch(toggleModal({ open: '' })); setSelectAll(false); }} style={{ left: '50%', transform: 'translateX(-50%)', bottom: '12px' }} width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
						<rect opacity="0.8" x="4" y="4" width="52" height="52" rx="26" fill="#151313" />
						<path d="M48.5626 11.4375C44.8913 7.76665 40.214 5.26685 35.1221 4.2542C30.0302 3.24156 24.7523 3.76155 19.9559 5.74843C15.1595 7.73531 11.06 11.0998 8.17569 15.4166C5.29142 19.7333 3.75195 24.8084 3.75195 30C3.75195 35.1917 5.29142 40.2667 8.17569 44.5835C11.06 48.9002 15.1595 52.2647 19.9559 54.2516C24.7523 56.2385 30.0302 56.7585 35.1221 55.7458C40.214 54.7332 44.8913 52.2334 48.5626 48.5625C51.0004 46.1249 52.9342 43.231 54.2535 40.0461C55.5729 36.8611 56.252 33.4474 56.252 30C56.252 26.5526 55.5729 23.1389 54.2535 19.954C52.9342 16.769 51.0004 13.8751 48.5626 11.4375ZM39.3751 36.6375C39.5624 36.8129 39.7117 37.0249 39.8138 37.2603C39.9159 37.4958 39.9686 37.7496 39.9686 38.0063C39.9686 38.2629 39.9159 38.5168 39.8138 38.7522C39.7117 38.9876 39.5624 39.1996 39.3751 39.375C39.1999 39.5488 38.9921 39.6863 38.7636 39.7796C38.5352 39.8729 38.2906 39.9202 38.0438 39.9188C37.5519 39.9167 37.0805 39.7214 36.7313 39.375L30.0001 32.6438L23.3626 39.375C23.0133 39.7214 22.5419 39.9167 22.0501 39.9188C21.8033 39.9202 21.5587 39.8729 21.3302 39.7796C21.1018 39.6863 20.894 39.5488 20.7188 39.375C20.3696 39.0237 20.1736 38.5485 20.1736 38.0531C20.1736 37.5578 20.3696 37.0826 20.7188 36.7313L27.3563 30L20.7188 23.3625C20.4116 23.0038 20.2511 22.5424 20.2694 22.0705C20.2876 21.5986 20.4832 21.151 20.8171 20.8171C21.1511 20.4832 21.5987 20.2875 22.0706 20.2693C22.5425 20.2511 23.0039 20.4116 23.3626 20.7188L30.0001 27.3563L36.6376 20.7188C36.8111 20.539 37.0184 20.3952 37.2476 20.2956C37.4768 20.196 37.7233 20.1424 37.9732 20.1381C38.223 20.1337 38.4713 20.1786 38.7038 20.2702C38.9363 20.3618 39.1484 20.4983 39.3282 20.6719C39.5079 20.8455 39.6517 21.0528 39.7514 21.2819C39.851 21.5111 39.9045 21.7576 39.9089 22.0075C39.9132 22.2573 39.8683 22.5056 39.7767 22.7381C39.6851 22.9706 39.5486 23.1828 39.3751 23.3625L32.6438 30L39.3751 36.6375Z" fill="white" />
					</svg>
				</div>
			</Modal>

			{/* Delete Company Audit Logs */}
			<Modal open={modal['open'] == 'deleteAuditLog'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h110vh df jcc aic">
				<div className="mah90 bg1 shadow w100 p3rem bsbb df fdc m1rem maw800px pr pt5rem br5px pr">
					<img className="h2rem pa t0 center-horizontally" src={require(`../../../../images/logo.svg`)} alt="TODO" style={{ top: '15px' }} />
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h1 className="text-gradient fs1-5rem fw600 tac ttu">{company?.['cName']} - Log</h1>
					<h2 className="c4 fs0-75rem ttu w100 tac mb1rem">See the history of {company?.['cName']} Updates</h2>
					<div className="ma oya dg gg0-5rem mb2rem w100">
						<div className="df my0-5rem">
							{company?.['creatorId']?.['profile']
								&& <img className={`ass ml0-5rem br100 w2rem h2rem bg3`} src={company?.['creatorId']['profile']} data-tooltip={company?.['creatorId'].firstName ? (company?.['creatorId'].firstName + " " + company?.['creatorId'].lastName) : "Register to show your name here"} />
								|| <span className={`ass w2rem h2rem fw600 mr0-5rem df jcc aic br100 bw1px bss bo16 fs0-75rem ${profileClass}`}>{company?.['creatorId']?.['firstName']?.[0] || "?"}{company?.['creatorId']?.['lastName']?.[0] || "?"}</span>
							}
							<div className="w100">
								<span className='fs0-75rem ml1rem'><b>{company?.['cName']} Updated</b> at <b>{new Date(company?.createdAt).toLocaleString()}</b> {company?.['creatorId'] && <> by <b>{company?.['creatorId']['firstName']} {company?.['creatorId']['lastName']}</b></>}</span>
								<div className="shadow bg5 br5px p1rem dg gg0-5rem my0-5rem fs0-75rem">
									<p className="df fw500 fs1rem mb0-5rem">{company?.['cName']} Info:</p>
									<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Name:</span> {company?.['cName']}</p>
									{company?.['creatorId'] && <p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Owner:</span> {company?.['creatorId']['firstName'] + ' ' + company?.['creatorId']['lastName']}</p>}
									<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Created At:</span> {moment(company?.['creaedAt']).format('ll')}</p>
									<p className='df fw500 ttc'><span className='fw600 mr0-5rem'>Company Objectives:</span> {company?.['testType']}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</Modal>

			{/* Warning modal for deleting company who has parrllel companies or are parent of group of companies  */}
			<Modal open={modal['open'] == 'warningDeleteCompany'} onClose={() => dispatch(toggleModal({ open: '' }))} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
				<div className="mah90 oya bg1 p3rem shadow w100 bsbb df fdc maw600px br5px pr">
					<button className="close-popup" onClick={() => dispatch(toggleModal({ open: '' }))}>
						<svg style={{ position: 'relative', top: '4px' }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
							<path className="pen fa-primary" d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z" />
						</svg>
					</button>
					<h2 className="c4 fs1-75rem ttu w100 tac mb1rem">Warning</h2>
					<div className="df fdc fs1rem mb1rem">
						<p>Before deleting this company, please ensure that all associated companies under this user are deleted first,
							as this is the primary company. Additionally,
							if this company has any subsidiary companies, you must first remove its status as the parent company in the group.
						</p>
					</div>
					<div className="df jcc fdc fdr-md aic fs1rem px1rem">
						<span onClick={() => dispatch(toggleModal({ open: '' }))}
							className="shadow my0-5rem bg3 bg4-hover c1 td250 br5px p0-5rem fw600 cp ttu w40 bsbb tac">
							Ok
						</span>
					</div>
				</div>
			</Modal>

		</AnimatedPage >
	);
}
